{
  "shippingFees": {
    "sectionTitle": "Frais de livraison",
    "sectionDescription": "Frais de livraison par variante, selon le service et la zone de destination. Les libellés de service et de zone sont traduits ; les codes techniques restent en anglais.",
    "columns": {
      "service": "Service",
      "zone": "Zone",
      "shippingFee": "Frais de livraison",
      "additionalFee": "Frais supplémentaire"
    },
    "columnHints": {
      "shippingFee": "Frais pour le premier article",
      "additionalFee": "Frais pour chaque article supplémentaire"
    },
    "addService": "Ajouter un service",
    "removeService": "Retirer le service",
    "zoneOverride": {
      "title": "Remplacements par zone",
      "description": "Remplacer les frais par défaut pour des zones de destination spécifiques.",
      "addZone": "Ajouter un remplacement de zone",
      "removeZone": "Retirer le remplacement de zone",
      "defaultZone": "Par défaut (toutes zones)"
    },
    "toasts": {
      "saved": "Frais de livraison enregistrés.",
      "error": "Échec de l'enregistrement des frais de livraison."
    },
    "errors": {
      "SHIPPING_SERVICE_FEE_REQUIRED": "Des frais de livraison sont requis pour le service sélectionné.",
      "BLUEPRINT_STANDARD_SERVICE_REQUIRED": "Des frais pour le service Standard national sont requis.",
      "SERVICE_CODE_INVALID": "Ce code de service n'est pas disponible dans le catalogue.",
      "SHIPPING_METHOD_IN_USE": "Ce service est encore utilisé et ne peut pas être retiré.",
      "feeRequired": "Saisissez des frais de livraison.",
      "feeInvalid": "Saisissez un montant de frais valide.",
      "duplicateService": "Ce service a déjà été ajouté.",
      "duplicateZone": "Cette zone possède déjà un remplacement."
    }
  },
  "shippingAggregation": {
    "_vgBinding": "vg-binding: P14.D-05 — Merchant Detail shippingAggregationMode toggle labels/helper/toasts (per_line|highest_base) across en/vi/fr [task-16]",
    "title": "Agrégation des frais de livraison",
    "ariaLabel": "Basculer le mode d'agrégation des frais de livraison",
    "readOnly": "Vous n'avez pas la permission de modifier ce paramètre.",
    "modes": {
      "per_line": "Par ligne",
      "highest_base": "Frais de base le plus élevé"
    },
    "helper": {
      "per_line": "Par ligne : les frais de livraison de chaque variante sont additionnés indépendamment sur toute la commande.",
      "highest_base": "Frais de base le plus élevé : le frais de base le plus élevé de la commande plus le frais supplémentaire pour les articles restants."
    },
    "toasts": {
      "saved": "Mode d'agrégation des frais de livraison mis à jour.",
      "error": "Échec de la mise à jour du mode d'agrégation des frais de livraison."
    }
  },
  "common": {
    "updatedDate": "Mis à jour"
  },
  "logisticsTable": {
    "selectAllRowsAria": "Sélectionner toutes les lignes",
    "columnStatus": "Statut",
    "statusToggleAria": "Basculer le statut de {{sku}}",
    "emptyGenerateOptionsFirst": "Aucun SKU — choisissez d’abord des options dans le bloc Options."
  },
  "category": {
    "title": "Catégories",
    "subtitle": "Arborescence des catégories produit",
    "columns": {
      "name": "Nom",
      "slug": "Slug",
      "parent": "Parent",
      "productCount": "Produits",
      "isActive": "Active"
    },
    "actions": {
      "create": "Créer une catégorie",
      "edit": "Modifier",
      "delete": "Supprimer",
      "reorder": "Réorganiser",
      "moveTo": "Déplacer vers"
    },
    "fields": {
      "name": "Nom",
      "slug": "Slug",
      "parent": "Catégorie parente",
      "description": "Description",
      "seoTitle": "Titre SEO",
      "seoDescription": "Description SEO",
      "image": "Image"
    },
    "errors": {
      "duplicateSlug": "Une catégorie avec ce slug existe déjà",
      "hasChildren": "Impossible de supprimer — la catégorie a des sous-catégories",
      "circularParent": "Une catégorie ne peut être son propre ancêtre"
    },
    "views": {
      "all": "Toutes",
      "active": "Actives",
      "inactive": "Inactives",
      "topLevel": "Niveau supérieur uniquement"
    },
    "page": {
      "subtitle": "Gérez l'arborescence de catégories à 2 niveaux affichée dans le catalogue storefront et la barre latérale admin des blueprints.",
      "filterViewsAria": "Vues de filtrage",
      "treeHeading": "Arborescence",
      "itemCount": "{{count}} éléments",
      "loadError": "Échec du chargement des catégories.",
      "retry": "Réessayer",
      "reorderFailed": "Échec de la réorganisation"
    },
    "detailPanel": {
      "emptySelect": "Sélectionnez une catégorie dans l'arborescence, ou cliquez sur « + Category » pour en ajouter une.",
      "nameRequired": "Le nom (anglais) est requis.",
      "created": "Catégorie créée.",
      "saved": "Catégorie enregistrée.",
      "saveFailed": "Échec de l'enregistrement.",
      "deleted": "« {{name}} » supprimée.",
      "cannotDeleteTitle": "Impossible de supprimer la catégorie",
      "cannotDeleteBody": "Cette catégorie a encore des blueprints assignés.",
      "deleteFailed": "Échec de la suppression.",
      "newCategory": "Nouvelle catégorie",
      "categoryFallback": "Catégorie",
      "idLabel": "ID : {{id}}",
      "nameEnLabel": "Nom (anglais)",
      "nameEnPlaceholder": "T-Shirts",
      "nameViLabel": "Nom (vietnamien)",
      "nameViPlaceholder": "Áo thun",
      "nameFrLabel": "Nom (français, facultatif)",
      "nameFrPlaceholder": "T-shirts",
      "slugLabel": "Slug d'URL",
      "slugPlaceholder": "t-shirts",
      "slugHint": "Minuscules, kebab-case, unique au sein du même niveau parent.",
      "topLevelOption": "— Niveau supérieur —",
      "depthHint": "Profondeur maximale : 2 niveaux (niveau supérieur → enfant uniquement).",
      "statusLabel": "Statut",
      "aliasLabel": "Alias (recherche alternative, facultatif)",
      "aliasPlaceholder": "Tees, Apparel Tops",
      "shortDescLabel": "Description courte (facultatif)",
      "shortDescPlaceholder": "T-shirts en coton doux avec impression intégrale",
      "imageLabel": "Image de la tuile (facultatif)",
      "imageHelper": "PNG / JPEG / SVG ≤ 5 Mo",
      "saveBtn": "Enregistrer les modifications",
      "cancel": "Annuler",
      "deleteConfirmTitle": "Supprimer la catégorie ?",
      "deleteConfirmPrefix": "Suppression de « ",
      "deleteConfirmSuffix": " » réversible depuis le journal de suppression logique, mais les blueprints actuellement assignés à cette catégorie bloqueront l'opération."
    },
    "seoForm": {
      "legend": "SEO",
      "defaultHint": "Par défaut : « {{value}} ».",
      "canonicalLabel": "URL canonique (facultatif)",
      "googleIndexLabel": "Autoriser Google à indexer cette catégorie",
      "keywordsLabel": "Mots-clés meta (facultatif)",
      "keywordsPlaceholder": "t-shirt, custom apparel, print on demand",
      "keywordsHint": "Termes séparés par des virgules (utilisés par certains moteurs de recherche).",
      "descriptionLabel": "Meta description"
    },
    "treeView": {
      "collapse": "Réduire",
      "expand": "Développer",
      "dragToReorder": "Glissez pour réordonner au sein du niveau",
      "addSub": "+ Sous",
      "empty": "Aucune catégorie pour l'instant. Cliquez sur « + Category » pour en ajouter une.",
      "treeAria": "Arborescence des catégories"
    },
    "list": {
      "pageTitle": "Catégorie et collection",
      "pageSubtitle": "Gérez la structure des catégories de produits, les parents, les sous-catégories et les canaux de catalogue actifs.",
      "tabCategory": "Catégorie",
      "tabCollection": "Collection",
      "searchPlaceholder": "Rechercher des catégories...",
      "searchAria": "Rechercher des catégories",
      "filterStatusAria": "Filtrer par statut",
      "filterStatusAll": "Statut : tous",
      "filterDisplayAria": "Filtrer par affichage",
      "filterDisplayAll": "Affichage : tous",
      "statusActive": "Actif",
      "statusInactive": "Inactif",
      "displayOn": "Activé",
      "displayOff": "Désactivé",
      "colName": "Nom",
      "colImage": "Image",
      "colLastUpdate": "Dernière mise à jour",
      "colUpdatedBy": "Mis à jour par",
      "colStatus": "Statut",
      "colDisplay": "Affichage",
      "colActions": "Actions",
      "dragColumnAria": "Réorganiser",
      "expand": "Développer",
      "collapse": "Réduire",
      "statusToggleAria": "Activer/désactiver le statut de {{name}}",
      "displayToggleAria": "Activer/désactiver l'affichage sur la page d'accueil de {{name}}",
      "editAria": "Modifier {{name}}",
      "viewProductsAria": "Voir les produits de {{name}}",
      "showingRange": "Affichage de {{from}} à {{to}} sur {{total}} catégories",
      "empty": "Aucune catégorie ne correspond à ces filtres.",
      "toggleFailed": "Impossible d'enregistrer la modification.",
      "rowsPerPage": "Lignes par page :",
      "paginationAria": "Pagination",
      "prevPage": "Page précédente",
      "nextPage": "Page suivante",
      "colCreatedAt": "Créé le",
      "toggleSaved": "Modification enregistrée.",
      "working": "Enregistrement…",
      "dragToReorder": "Faites glisser pour réordonner au sein du même niveau",
      "reorderSaved": "Ordre mis à jour."
    },
    "form": {
      "createTitle": "Créer une catégorie",
      "editTitle": "Modifier la catégorie",
      "breadcrumbAria": "Fil d'Ariane",
      "crumbBlueprint": "Blueprint",
      "crumbCreate": "Créer",
      "crumbEdit": "Modifier",
      "basicInfo": "Informations de base",
      "nameLabel": "Nom",
      "namePlaceholder": "Saisissez le nom de la catégorie",
      "slugLabel": "Slug",
      "slugPlaceholder": "Généré automatiquement",
      "slugHelper": "Le slug est généré automatiquement à partir du nom de la catégorie et sert à construire l'URL.",
      "aliasLabel": "Alias",
      "aliasPlaceholder": "Saisissez le nom d'affichage",
      "imageLabel": "Image",
      "imageHelper": "5 Mo maximum. PNG, JPG ou WebP.",
      "imageRemove": "Supprimer",
      "shortDescLabel": "Description courte",
      "shortDescPlaceholder": "Décrivez votre catégorie en détail pour le catalogue...",
      "parentLabel": "Catégorie parente",
      "parentNone": "Aucune (niveau supérieur)",
      "parentHelper": "Seules les catégories de niveau 1 peuvent être choisies comme catégorie parente.",
      "productsHeading": "Produits",
      "productsEmptyTitle": "Aucun produit sélectionné",
      "productsEmptyBody": "Sélectionnez des produits pour les rattacher à cette catégorie.",
      "productsSelected": "{{count}} produits sélectionnés",
      "productsSelectedBody": "Ces produits sont rattachés spécifiquement à cette catégorie.",
      "selectProducts": "Sélectionner des produits",
      "manageProducts": "Gérer les produits",
      "seoHeading": "Paramètres SEO",
      "seoSubtitle": "Optimisez l'affichage de cette catégorie dans les moteurs de recherche.",
      "seoTitleLabel": "Titre SEO",
      "seoTitlePlaceholder": "Saisissez le titre SEO",
      "seoTitleHelper": "Si ce champ est vide, le système peut utiliser l'alias automatiquement.",
      "canonicalLabel": "URL canonique",
      "canonicalPlaceholder": "https://example.com/category/...",
      "canonicalHelper": "URL privilégiée par les moteurs de recherche pour éviter le contenu dupliqué.",
      "googleIndexLabel": "Indexation Google",
      "metaKeywordsLabel": "Mots-clés meta",
      "metaKeywordsPlaceholder": "Saisissez un mot-clé puis appuyez sur Entrée",
      "metaKeywordRemove": "Supprimer le mot-clé {{keyword}}",
      "metaDescriptionLabel": "Meta description",
      "metaDescriptionPlaceholder": "Saisissez un résumé court pour les moteurs de recherche...",
      "metaDescriptionHelper": "Longueur recommandée : 150 à 160 caractères.",
      "metaDescriptionCounter": "{{count}} / {{max}} caractères",
      "stateDrafted": "Toutes les modifications sont en brouillon",
      "stateSaved": "Toutes les modifications sont enregistrées",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "saveCategory": "Enregistrer la catégorie",
      "saveChanges": "Enregistrer les modifications",
      "savedCreate": "Catégorie créée.",
      "savedEdit": "Catégorie enregistrée.",
      "saveFailed": "Échec de l'enregistrement.",
      "loadError": "Impossible de charger cette catégorie.",
      "errors": {
        "nameRequired": "Veuillez saisir le nom de la catégorie.",
        "nameDuplicate": "Ce nom de catégorie existe déjà. Veuillez en saisir un autre.",
        "aliasRequired": "Veuillez saisir l'alias.",
        "canonicalInvalid": "L'URL canonique n'est pas valide.",
        "metaDescriptionTooLong": "La meta description dépasse la longueur maximale autorisée.",
        "parentMustBeLevel1": "Seules les catégories de niveau 1 peuvent être choisies comme catégorie parente.",
        "hasChildren": "Cet élément a {{count}} sous-élément(s) et ne peut pas devenir l'enfant d'un autre. Déplacez-les d'abord.",
        "productsRequired": "Sélectionnez au moins un produit."
      },
      "imageUpload": "Téléverser une image",
      "imageUploading": "Téléversement…",
      "imageChange": "Changer",
      "imageTypeError": "Seules les images PNG, JPG ou WebP sont acceptées.",
      "imageSizeError": "Image trop volumineuse — maximum {{max}}.",
      "imageUploadError": "Échec du téléversement de l'image.",
      "loadingOptions": "Chargement…",
      "parentLockedHelper": "Cet élément a {{count}} sous-élément(s) et ne peut donc pas devenir l'enfant d'un autre — l'arborescence est limitée à 2 niveaux. Déplacez-les d'abord."
    },
    "products": {
      "dialogTitle": "Sélectionner des produits",
      "dialogSubtitle": "Recherchez et sélectionnez les produits à rattacher à cette catégorie.",
      "searchPlaceholder": "Rechercher des produits...",
      "filterStatusAria": "Filtrer les produits par statut",
      "filterStatusAll": "Statut : tous",
      "statusActive": "Actif",
      "statusDraft": "Brouillon",
      "statusInactive": "Inactif",
      "showSelectedOnly": "Afficher uniquement la sélection",
      "selectAllOnPage": "Sélectionner tous les produits de cette page",
      "selectRowAria": "Sélectionner {{name}}",
      "colImage": "Image",
      "colName": "Nom du produit",
      "colBlueprint": "Blueprint",
      "colSkuCount": "Nombre de SKU",
      "colStatus": "Statut",
      "skuCount": "{{count}} SKU",
      "showingRange": "Affichage de {{from}} à {{to}} sur {{total}} produits",
      "selectedCount": "{{count}} sélectionné(s)",
      "empty": "Aucun produit ne correspond à ces filtres.",
      "loadError": "Impossible de charger les produits.",
      "status": {
        "Active": "Actif",
        "Draft": "Brouillon",
        "Inactive": "Inactif"
      },
      "takenBy": "Déjà dans « {{category}} »",
      "takenByUnnamed": "Déjà dans une autre catégorie"
    }
  },
  "blueprint": {
    "title": "Blueprints",
    "subtitle": "Modèles de produits (blueprints)",
    "columns": {
      "name": "Nom",
      "category": "Catégorie",
      "techniques": "Techniques",
      "basePrice": "Prix de base",
      "isActive": "Active",
      "nameCode": "Nom/Code",
      "status": "Statut",
      "location": "Zone",
      "publishTime": "Date de publication",
      "creator": "Créateur",
      "lastUpdated": "Dernière mise à jour",
      "vendors": "Fournisseurs",
      "source": "Source",
      "activeAction": "En vente",
      "actions": "Actions"
    },
    "actions": {
      "create": "Créer un blueprint",
      "edit": "Modifier",
      "duplicate": "Dupliquer",
      "archive": "Archiver",
      "import": "Importer",
      "export": "Exporter",
      "exporting": "Export…"
    },
    "detail": {
      "tabs": {
        "info": "Informations",
        "variants": "Variantes",
        "techniques": "Techniques",
        "pricing": "Tarification",
        "addOns": "Compléments",
        "media": "Médias",
        "seo": "SEO"
      }
    },
    "wizard": {
      "title": "Créer un blueprint",
      "subtitle": "Assistant 3 étapes. La soumission place le blueprint dans la file d'approbation produit pour un contrôle maker-checker.",
      "steps": {
        "information": "1. Informations",
        "attributes": "2. Attributs",
        "preview": "3. Aperçu"
      },
      "type": {
        "label": "Type",
        "locked": "Product (verrouillé)"
      },
      "productCode": "Code produit",
      "productCodeHint": "3-12 caractères, lettres majuscules ou chiffres.",
      "productName": "Nom du produit (EN)",
      "slug": "Slug",
      "slugHint": "Généré depuis le nom ; modifiable.",
      "category": "Catégorie",
      "collections": "Collections",
      "technology": "Technologie (sélection multiple)",
      "productionType": {
        "label": "Type de production",
        "printing": "Impression",
        "embroidery": "Broderie"
      },
      "processingTime": {
        "label": "Temps de traitement (jours)",
        "fromDays": "De",
        "toDays": "À"
      },
      "scheduledPublish": "Publication programmée",
      "scheduledPublishHint": "Laisser vide pour publier immédiatement après approbation.",
      "templates": "Templates de blueprint",
      "templatesHint": "Les templates de niveau blueprint sont propagés à toutes les variantes sans override explicite.",
      "images": "Images",
      "imagesDrop": "Déposez les images ici ou cliquez pour sélectionner",
      "imagesAccept": "JPEG / PNG / WEBP — jusqu'à 10 images, 5+ requises pour publier.",
      "description": "Description",
      "guideline": "Guide",
      "videoUrl": "URL vidéo",
      "videoUrlHint": "Doit être une URL YouTube ou Vimeo.",
      "attributes": {
        "title": "Générateur de SKU",
        "subtitle": "Sélectionnez options et valeurs, puis dépliez le produit cartésien.",
        "addOption": "Ajouter une option",
        "generate": "Générer les SKU",
        "preview": "Aperçu"
      },
      "sku": {
        "table": "Tableau SKU",
        "addBlank": "Ajouter un SKU vide",
        "code": "SKU",
        "attributes": "Attributs",
        "weight": "Poids (g)",
        "dim": {
          "l": "L",
          "w": "l",
          "h": "H"
        },
        "templates": "Templates"
      },
      "preview": {
        "information": "Informations",
        "skuTable": "Tableau SKU",
        "publishNotReady": "Moins de 5 images. L'approbateur bloquera la publication jusqu'à 5+ images.",
        "submitNote": "La soumission place ce blueprint dans la file d'approbation produit (admin self-create). Un autre admin doit approuver avant publication."
      },
      "actions": {
        "cancel": "Annuler",
        "back": "Retour",
        "next": "Suivant",
        "submit": "Soumettre pour approbation",
        "submitting": "Envoi…"
      },
      "create": {
        "pageSubtitle": "L'envoi place ce blueprint dans la file d'Approbation des produits pour une revue maker-checker.",
        "stepCounter": "Étape {{current}} sur {{total}}",
        "stepperAria": "Progression de l'assistant",
        "steps": {
          "information": "Informations",
          "attributes": "Attributs",
          "logistics": "Logistique",
          "settings": "Paramètres",
          "preview": "Aperçu"
        },
        "actions": {
          "continue": "Continuer ›",
          "goBack": "‹ Retour",
          "submitForApproval": "Soumettre pour approbation",
          "apply": "Appliquer",
          "creating": "Création…",
          "addLocation": "+ Ajouter un emplacement",
          "addVendor": "+ Ajouter un fournisseur",
          "save": "Enregistrer"
        },
        "type": {
          "label": "Type :",
          "product": "Produit",
          "cannotChange": "(Non modifiable après création)"
        },
        "checking": "Vérification de la disponibilité…",
        "code": {
          "invalid": "3 à 12 lettres majuscules ou chiffres.",
          "taken": "Ce code Blueprint est déjà utilisé — choisissez-en un autre.",
          "available": "Code Blueprint disponible.",
          "placeholder": "Saisir le code produit"
        },
        "slug": {
          "taken": "Un produit avec ce nom (slug \"{{slug}}\") existe déjà — choisissez un autre nom."
        },
        "fields": {
          "blueprintCode": "Code",
          "blueprintName": "Nom",
          "blueprintNamePlaceholder": "Saisir le nom du produit",
          "skuType": "Type de SKU",
          "category": "Catégorie",
          "categoryPlaceholder": "Sélectionner une catégorie",
          "categoryRequired": "La catégorie est obligatoire",
          "collection": "Collection",
          "productionType": "Type",
          "technology": "Technique",
          "processingTime": "Délai de traitement",
          "publishTime": "Heure de publication",
          "description": "Description",
          "guideline": "Consignes",
          "videoUrl": "URL de la vidéo",
          "images": "Images",
          "uploadedThumbnails": "Vignettes téléchargées",
          "chargeForEmbroidery": "Facturer la broderie",
          "maxEmbroideryColors": "Couleurs de broderie max.",
          "youtubeVideoUrl": "URL de la vidéo Youtube",
          "technologyRequired": "La technologie est un champ obligatoire",
          "processingTimeRequired": "Le délai de traitement est un champ obligatoire",
          "processingTimeInverted": "Le nombre de jours « De » doit être inférieur au nombre de jours « À »",
          "blueprintNameRequired": "Le nom du blueprint est un champ obligatoire",
          "blueprintCodeRequired": "Le code blueprint est un champ obligatoire",
          "imagesRequired": "Les images sont un champ obligatoire — ajoutez-en {{count}} de plus (minimum {{min}})",
          "searchCategory": "Rechercher des catégories…",
          "searchingCategories": "Recherche…",
          "noCategoryOptions": "Aucune catégorie active ne correspond."
        },
        "skuType": {
          "product": "Produit",
          "accessory": "Accessoires"
        },
        "category": {
          "quickCreateAria": "Créer rapidement une nouvelle catégorie",
          "quickCreateTitle": "Créer rapidement une catégorie"
        },
        "collection": {
          "loading": "Chargement des collections…",
          "searchPlaceholder": "Rechercher une collection...",
          "dropdownLoading": "Chargement…",
          "emptyHint": "Aucune collection. Utilisez le bouton « + » pour en créer une.",
          "noMatch": "Aucune collection ne correspond à « {{query}} ».",
          "quickCreateAria": "Créer rapidement une nouvelle collection",
          "quickCreateTitle": "Créer rapidement une collection",
          "removeAria": "Retirer la collection {{name}}"
        },
        "productionType": {
          "aria": "Type de production",
          "printing": "Impression",
          "embroidery": "Broderie",
          "cutting": "Découpe",
          "blank": "Vierge"
        },
        "technology": {
          "hint": "Veuillez sélectionner au moins une technologie"
        },
        "processing": {
          "to": "À",
          "days": "jours",
          "from": "De",
          "businessDays": "jours ouvrés",
          "figmaHint": "Durée de production estimée, en jours ouvrés."
        },
        "publish": {
          "hint": "Planifier l'heure de publication"
        },
        "videoUrl": {
          "hint": "Saisir l'URL de la vidéo (YouTube, etc.)",
          "invalid": "Doit être une URL YouTube ou Vimeo.",
          "placeholder": "https://youtube.com/watch?v=...",
          "figmaHint": "Donnez vie à votre photo avec une vidéo de 5 à 15 secondes — cela peut booster vos ventes !"
        },
        "images": {
          "dropHint": "Glissez-déposez des images ici, ou",
          "uploadAria": "Télécharger des images mockup",
          "uploading": "Téléchargement…",
          "uploadButton": "Télécharger des images",
          "helper": "JPEG / PNG — jusqu'à 10 images. Au moins {{min}} images requises",
          "helperMissing": " (il en manque {{count}}).",
          "previewAria": "Aperçu de {{name}}",
          "reorderTitle": "Faites glisser la carte pour réordonner",
          "remove": "Supprimer",
          "empty": "Aucune image téléchargée",
          "emptyHint": "Les vignettes apparaîtront ici",
          "needMore": "Il manque encore {{count}} image(s) avant de débloquer la publication.",
          "primaryBadge": "Principale",
          "figmaHelper": "Importez entre {{min}} et {{max}} images. La première sera la photo principale du produit. Glissez pour réordonner."
        },
        "location": {
          "title": "Emplacement & Fournisseur",
          "subtitle": "Sélectionner Emplacement & Fournisseur",
          "emptyBound": "Aucun emplacement lié pour l'instant. Cliquez sur « + Ajouter un emplacement » pour choisir dans le catalogue des emplacements d'exécution.",
          "vendors": "Fournisseurs",
          "selectDefaultHint": "Sélectionnez le fournisseur par défaut avec le bouton radio.",
          "markDefaultAria": "Définir comme fournisseur par défaut",
          "pickVendorFirstTitle": "Choisissez un fournisseur avant de le définir par défaut",
          "minVendorTitle": "Au moins un fournisseur requis par emplacement",
          "removeVendorTitle": "Supprimer le fournisseur",
          "vendorListEmpty": "Au moins un fournisseur requis par emplacement.",
          "pickDefaultVendor": "Choisissez un fournisseur pour le bouton radio par défaut.",
          "defaultLocation": "Emplacement par défaut",
          "addLocation": "Ajouter un emplacement",
          "noneExist1": "Aucun emplacement n'existe encore. Créez-en un sur la",
          "fulfillmentLocationsLink": "page Emplacements d'exécution",
          "noneExist2": "d'abord.",
          "perSkuNote": "La liaison emplacement & fournisseur par SKU se configure sur la page de détail du Blueprint après la création.",
          "selectVendor": "Sélectionner des vendeurs",
          "noLocationOptions": "Aucun site de production disponible.",
          "noVendorOptions": "Aucun vendeur disponible.",
          "vendorSharePctAria": "Part des commandes pour {{vendor}}, en pourcentage",
          "pctSumOk": "Σ 100 % — répartition valide",
          "pctSumInvalid": "Σ {{sum}} % — le total doit atteindre 100 %",
          "searchVendor": "Rechercher des fournisseurs…",
          "searchingVendors": "Recherche de fournisseurs…",
          "pctSumUnbound": "Σ {{sum}}% — une part revient à un vendeur non sélectionné"
        },
        "selectLocation": "— Sélectionner un emplacement —",
        "selectVendor": "Sélectionner un fournisseur…",
        "removeLocationAria": "Supprimer l'emplacement",
        "removeVendorAria": "Supprimer le fournisseur",
        "tiktok": {
          "title": "Configuration TikTok",
          "subtitle": "Cochez chaque fournisseur qui expédie via TikTok.",
          "emptyHint": "Choisissez un emplacement et un fournisseur ci-dessus pour mapper les fournisseurs à l'expédition TikTok.",
          "noVendor": "Aucun fournisseur sélectionné",
          "defaultBadge": "Par défaut"
        },
        "skuList": {
          "title": "Liste des SKU",
          "count": "{{count}} SKU",
          "import": "Importer Excel",
          "export": "Exporter Excel",
          "filterBy": "Filtrer par :",
          "noAttrGroups": "Aucun groupe d'attributs — utilisez le générateur ci-dessus.",
          "selectedCount": "{{count}} SKU sélectionnés",
          "templateLabel": "Modèle :",
          "bulkTemplateAria": "Assigner des modèles en masse",
          "skuTypeLabel": "Type de SKU :",
          "tierPriceLabel": "Prix par palier :",
          "bulkEditPrices": "Modifier les prix en masse",
          "deselect": "Désélectionner",
          "empty": "Aucun SKU. Choisissez des options à gauche — le tableau se remplit automatiquement.",
          "pricesNote": "Prix en centimes (ex. 1099 = 10,99 $). Les cellules vides ignorent ce couple variante×palier. La logistique (poids / dimensions / frais d'expédition par service) se modifie sur la page de détail du Blueprint après création.",
          "clearFilters": "Effacer les filtres",
          "noFilterMatch": "Aucun SKU ne correspond aux filtres sélectionnés.",
          "exportSuccess": "{{count}} SKU exportés",
          "exportEmptyTemplate": "Aucun SKU pour l'instant — modèle vide exporté. Remplissez-le et réimportez.",
          "exportError": "Échec de l'export",
          "exportHint": "Télécharger la liste des SKU (.xlsx) : SKU, attributs, type, prix par palier, frais d'expédition par service, logistique et état.",
          "importDone": "{{updated}} SKU mis à jour, {{skipped}} ignorés",
          "importError": "Échec de l'import — vérifiez que le fichier correspond au format exporté",
          "importHint": "Importez un .xlsx/.csv pour créer ou mettre à jour des SKU. Les valeurs d'attributs doivent déjà exister dans le catalogue (Products → Options) ; prix et frais d'expédition en $.",
          "importEmpty": "Le fichier ne contient aucune ligne.",
          "importNoMatch": "Aucun SKU ne correspond. L'import ne met à jour que les SKU déjà générés depuis les options — exportez d'abord pour obtenir le modèle exact, modifiez-le puis réimportez.",
          "importOptionsLoading": "Catalogue d'options pas encore chargé — patientez puis réessayez l'import.",
          "importCreated": "{{created}} SKU créés, {{updated}} mis à jour, {{skipped}} ignorés",
          "importUnresolved": "Aucun SKU importé — ces valeurs d'attributs sont absentes du catalogue : {{missing}}. Ajoutez-les dans Products → Options d'abord.",
          "importNoRows": "Aucun SKU importé — vérifiez que les colonnes SKU + Attributes correspondent au modèle exporté.",
          "importTemplatesUnresolved": "Codes de template inconnus ignorés : {{codes}}. Utilisez le CODE exact (visible via Export).",
          "optionFilterLabel": "Option :",
          "rowsPerPage": "Lignes par page :",
          "showingRange": "Affichage {{from}}–{{to}} sur {{total}} SKU",
          "prevPage": "Page précédente",
          "nextPage": "Page suivante",
          "vendorFilterLabel": "Vendeur :",
          "allVendors": "Tous les vendeurs",
          "allOptions": "Toutes les options",
          "bulkEdit": "Modifier",
          "bulkAssignTemplate": "Affecter un modèle",
          "bulkSetDimension": "Définir les dimensions",
          "copyPricesPrompt": "Cet emplacement n'a pas encore de prix.",
          "copyPricesFrom": "Copier depuis {{from}}",
          "copyPricesDone": "Prix copiés depuis {{from}}.",
          "bulkMarkSmall": "Marquer Petit",
          "bulkUnmarkSmall": "Retirer Petit"
        },
        "skuTable": {
          "selectAllAria": "Sélectionner tous les SKU",
          "code": "SKU",
          "attributes": "Attributs",
          "templates": "Modèle",
          "type": "Type",
          "selectRowAria": "Sélectionner le SKU {{sku}}",
          "codeReadonlyTitle": "SKU généré à partir des valeurs d'option (lecture seule)",
          "editTemplatesAria": "Modifier les modèles de ce SKU",
          "priceMonotonicTitle": "{{tier}} ({{current}}) doit rester inférieur à {{higherTier}} ({{higherValue}}).",
          "toggleActiveTitle": "SKU Inactif — cliquez pour le réactiver",
          "toggleInactiveTitle": "SKU Actif — cliquez pour le désactiver",
          "inactive": "Inactif",
          "active": "Actif",
          "action": "Action",
          "vendor": "Vendeur",
          "dimension": "Dimensions",
          "status": "Statut",
          "assign": "Affecter",
          "set": "Définir",
          "view": "Voir",
          "viewCount": "Voir ({{count}})",
          "templatesCount": "Gabarit ({{count}})",
          "dimensionAria": "Définir les dimensions de {{sku}}",
          "priceZeroTitle": "Le prix doit être supérieur à 0.",
          "tierWithUnit": "{{tier}} ($)",
          "priceRequiredTitle": "Un prix est obligatoire pour ce palier.",
          "dimensionFormat": "Poids x H x l x L",
          "dimensionValueAria": "Poids {{weight}} g, boîte {{height}} x {{width}} x {{length}} po",
          "small": "Petit",
          "smallAria": "Marquer {{sku}} comme petit produit",
          "dimensionValueWithUnit": "{{weight}} g x {{height}} po x {{width}} po x {{length}} po"
        },
        "skuTypeLabels": {
          "product": "Produit",
          "small_product": "Petit produit",
          "accessory": "Accessoires"
        },
        "logistics": {
          "descriptionExtra": "— Les blueprints Actifs exigent ces champs au moment de l'approbation ; une logistique incomplète bloquera le passage à Actif.",
          "exportSuccess": "{{count}} lignes exportées",
          "exportError": "Échec de l'export",
          "exportHint": "Télécharger la logistique (.xlsx) : SKU, poids, dimensions avec unités et frais d'expédition par service ($).",
          "importEmpty": "Le fichier ne contient aucune ligne.",
          "importNoMatch": "Aucun SKU ne correspond — exportez d'abord le modèle, remplissez-le puis réimportez.",
          "importDone": "{{updated}} mis à jour, {{skipped}} ignorés",
          "importError": "Échec de l'import — vérifiez le format du fichier exporté",
          "importFeeInvalid": "Frais d'expédition ignorés dans : {{columns}} — doit être un nombre entre 0 et 10000.",
          "importWrongLocation": "Ce fichier contient les tarifs de {{sheet}}, mais l'onglet ouvert est {{active}}. Passez à l'onglet de cette localisation, puis importez.",
          "importHint": "Importer un .xlsx/.csv pour mettre à jour poids, dimensions (avec unités) et frais d'expédition, par SKU."
        },
        "preview": {
          "logisticsBanner": "⚠ La logistique (poids + longueur/largeur/hauteur + frais par service) est incomplète. Vous pouvez enregistrer en brouillon, mais l’approbateur bloquera le passage à Actif jusqu’à ce qu’elle soit complète. Terminez-la dans le bloc Logistique ci-dessus.",
          "information": "Informations",
          "nameEn": "Nom (EN)",
          "slug": "Slug",
          "collections": "Collections",
          "technologies": "Technologies",
          "selectedCount": "{{count}} sélectionnées",
          "processingTime": "Délai de traitement",
          "daysRange": "{{from}}–{{to}} jours",
          "publishAt": "Publier le",
          "immediate": "Immédiat à l'approbation",
          "templates": "Modèles",
          "images": "Images",
          "publishReady": "prêt à publier",
          "needFive": "5+ requis",
          "skuTable": "Tableau des SKU",
          "skuSummary": "{{skus}} SKU — {{entries}} entrées de prix.",
          "noSkus": "Aucun SKU — choisissez des options dans le bloc Options pour les générer avant d’enregistrer.",
          "noPricesWarn": "⚠ Aucun tarif défini. L’approbateur verra des tarifs vides — renseignez-les dans le bloc Tarifs ci-dessus, ou enregistrez et modifiez-les sur la page de détail après approbation.",
          "imageCountWarn": "⚠ Le nombre d'images est de {{count}}/5. L'approbateur maker-checker bloquera la publication jusqu'à ce que 5+ images soient téléchargées.",
          "noAreasBanner": "Aucun SKU n'a de Template assigné, ce produit n'aura donc aucune zone d'impression — il ne pourra pas être mis en vente tant qu'il n'y a pas au moins une zone. Assignez un Template à l'étape Attributs, ou ajoutez les zones plus tard depuis la page du produit.",
          "submitNote": "L'envoi place ce blueprint dans la file d'Approbation des produits (création par l'admin). Un second admin doit approuver avant la publication."
        },
        "templatePicker": {
          "aria": "Sélectionner un modèle",
          "title": "Sélectionner un modèle",
          "searchPlaceholder": "Rechercher des modèles…",
          "empty": "Aucun modèle de blueprint disponible. Ajoutez d'abord des modèles sur la page catalogue.",
          "noMatch": "Aucun modèle ne correspond à \"{{query}}\".",
          "select": "Choisir",
          "deselectAria": "Retirer {{name}}"
        },
        "vendorPicker": {
          "aria": "Assigner fournisseur/emplacement au SKU",
          "title": "Fournisseur / Emplacement — {{sku}}",
          "titleBulk": "Fournisseur / Emplacement — {{count}} SKU",
          "description": "Assignez emplacement + fournisseur au SKU. La colonne % des commandes répartit par emplacement : chaque emplacement doit totaliser 100 pour répartir les commandes proportionnellement ; laisser vide = le routage choisit le fournisseur le mieux noté.",
          "empty1": "Aucun emplacement. Cliquez sur",
          "empty2": "pour commencer.",
          "location": "Emplacement",
          "default": "Par défaut",
          "vendor": "Fournisseur",
          "orderPercent": "% des commandes",
          "noVendor": "Aucun fournisseur. Cliquez sur « + Ajouter un fournisseur ».",
          "pickLocationFirst": "Choisissez d'abord un emplacement",
          "sumNoSplit": "Pas de répartition — le routage choisit le fournisseur le mieux noté",
          "sumValid": "Valide — répartition en %",
          "sumInvalid": "Le total % de cet emplacement doit être égal à 100 (ou tout laisser vide)",
          "sumNeed100Suffix": " — doit être égal à 100",
          "locationsIncomplete": "{{count}} emplacement(s) n'atteignent pas 100 % — impossible d'enregistrer",
          "percentValid": "% valides — répartition par emplacement",
          "weightWarnTitle": "Chaque emplacement doit totaliser 100 %, ou tout laisser vide (pas de répartition). Impossible d'appliquer tant qu'un emplacement est incomplet.",
          "applyInvalidTitle": "Le % d'un emplacement est invalide (≠100 et ≠0) — réglez-le à 100 ou effacez tous les %"
        },
        "bulkPrice": {
          "aria": "Modifier les prix par palier en masse",
          "title": "Modifier les prix en masse — {{count}} SKU",
          "hint": "Laissez un palier vide pour conserver son prix actuel par SKU. Les valeurs saisies écrasent chaque SKU sélectionné.",
          "noTiers": "Aucun palier de prix configuré.",
          "pricePlaceholder": "ex. 1099 (= 10,99 $)",
          "monotonicWarn": "⚠ {{tier}} ({{current}}) ≥ {{higherTier}} ({{higherValue}}). Les paliers supérieurs doivent rester au-dessus des paliers inférieurs."
        },
        "imagePreview": {
          "aria": "Aperçu de {{name}}",
          "ariaDefault": "Aperçu de l'image",
          "closeAria": "Fermer l'aperçu"
        },
        "categoryModal": {
          "aria": "Ajout rapide de catégorie",
          "title": "Ajout rapide de catégorie",
          "code": "Code de catégorie",
          "name": "Nom de la catégorie",
          "namePlaceholder": "T-Shirt",
          "parent": "Catégorie parente",
          "rootCategory": "Catégorie racine",
          "submit": "Créer la catégorie"
        },
        "collectionModal": {
          "aria": "Créer une nouvelle collection",
          "title": "Créer une nouvelle collection",
          "nameEn": "Nom (EN)",
          "nameEnPlaceholder": "ex. Spring 2026",
          "nameVi": "Nom (VI)",
          "nameViPlaceholder": "ex. Mùa xuân 2026",
          "slug": "Slug",
          "slugPlaceholder": "dérivé automatiquement du nom",
          "slugHint": "Dérivé automatiquement du nom ; modifiez pour remplacer.",
          "submit": "Créer la collection"
        },
        "confirm": {
          "discard": "Abandonner le brouillon non enregistré et quitter ?"
        },
        "addons": {
          "heading": "Options",
          "description": "Extras facultatifs qu’un marchand peut ajouter en commandant ce produit.",
          "enable": "Activer les options",
          "disabledHint": "Les options sont désactivées pour ce produit. Activez-les pour choisir celles qui s’appliquent.",
          "addLabel": "Ajouter une option",
          "selectAddon": "Sélectionner une option…",
          "noMore": "Plus aucune option disponible",
          "loading": "Chargement des options…",
          "add": "Ajouter",
          "remove": "Retirer",
          "empty": "Aucune option sélectionnée.",
          "colName": "Nom",
          "colMode": "Mode",
          "colRequired": "Obligatoire",
          "colActions": "Actions",
          "requiredSuffix": ", obligatoire",
          "yes": "Oui",
          "no": "Non",
          "linkedOnCreateHint": "Ces options sont liées après la création du produit. Vous pourrez les modifier depuis l’étape Settings du produit."
        },
        "toast": {
          "categoryNameRequiredTitle": "Nom de catégorie requis",
          "categoryNameRequiredDesc": "Saisissez le nom de la catégorie.",
          "categoryCodeRequiredTitle": "Code de catégorie requis",
          "categoryCodeRequiredDesc": "Saisissez un code (ex. DM-001).",
          "categoryCodeInvalidTitle": "Code de catégorie invalide",
          "categoryCodeInvalidDesc": "Le code doit contenir des lettres ou des chiffres.",
          "categoryCreateFailTitle": "Échec de la création de la catégorie",
          "categoryCreatedTitle": "Catégorie créée",
          "categoryCreatedDesc": "{{name}} prête à l'emploi.",
          "networkError": "Erreur réseau",
          "collectionNameRequiredTitle": "Nom requis",
          "collectionNameRequiredDesc": "Saisissez le nom de la collection (EN).",
          "collectionCreateFailTitle": "Échec de la création de la collection",
          "collectionCreatedTitle": "Collection créée",
          "collectionCreatedDesc": "{{name}} prête à l'emploi.",
          "uploadFailedReason": "échec du téléchargement",
          "more": "de plus",
          "skippedUnsupportedTitle": "{{count}} fichier(s) non pris en charge ignoré(s)",
          "skippedUnsupportedDesc": "Seuls JPEG / PNG sont autorisés. Ignorés : {{files}}",
          "imageCapTitle": "Limite d'images atteinte",
          "imageCapDesc": "Seules 10 images sont autorisées à la création. {{count}} fichier(s) ignoré(s).",
          "uploadFailedTitle": "{{count}} téléchargement(s) échoué(s)",
          "step1ImagesDesc": "Au moins {{min}} images mockup requises (actuellement {{current}}). Ajoutez des images avant de continuer.",
          "step1FixFields": "Corrigez les champs en surbrillance avant de continuer.",
          "step1IncompleteTitle": "Bloc Détails incomplet",
          "skuUniqueDesc": "Chaque SKU doit être unique et non vide.",
          "skuAddOneDesc": "Ajoutez au moins un SKU avant de continuer.",
          "skuMissingTemplateDesc": "{{count}} SKU sans modèle. Utilisez le bouton + par ligne ou l'action Modèle en masse.",
          "step2IncompleteTitle": "Bloc Options incomplet",
          "locationRequiredTitle": "Emplacement & Fournisseur requis",
          "locationRequiredDesc": "Associez au moins un Emplacement avec un Fournisseur avant de continuer. Un blueprint ne peut pas être créé sans Emplacement & Fournisseur.",
          "logisticsIncompleteTitle": "Logistique incomplète",
          "logisticsIncompleteDesc": "Certains SKU n'ont pas de poids / dimensions / frais d'expédition par service. Vous pouvez continuer en brouillon — la validation s'exécute à l'étape d'approbation.",
          "createFailTitle": "Échec de la création du blueprint",
          "submittedTitle": "Soumis pour approbation",
          "submittedDesc": "Le blueprint est maintenant dans la file d'Approbation des produits.",
          "importTitle": "Import non encore disponible",
          "importDesc": "L'import depuis l'assistant est prévu sur la page de détail du Blueprint après création (xlsx).",
          "exportTitle": "Export non encore disponible",
          "exportDesc": "L'export est disponible depuis la page de détail du Blueprint après création (xlsx).",
          "priceZeroTitle": "Le prix ne peut pas être 0",
          "priceZeroDesc": "{{count}} cellule(s) de prix sont à 0. Saisissez un prix supérieur à 0, ou videz la cellule pour laisser ce palier sans prix.",
          "step1MissingFields": "Veuillez renseigner les champs obligatoires : {{fields}}.",
          "priceRequiredDesc": "{{count}} champ(s) de prix sont vides. Chaque SKU doit avoir un prix pour chaque palier avant de continuer.",
          "tierOrderDesc": "{{count}} cellule(s) de prix rompent l’échelle des paliers — un palier inférieur doit coûter moins que celui au-dessus.",
          "optionRowIncomplete": "{{count}} ligne(s) d’option incomplètes — choisissez une option et au moins une valeur, ou supprimez la ligne."
        },
        "vendorCell": {
          "unassigned": "Non attribué"
        },
        "tocAria": "Sections du blueprint",
        "nothingSavedYet": "Rien n'est enregistré — appuyez sur Enregistrer pour créer",
        "blocks": {
          "details": "Détails",
          "techniques": "Techniques",
          "mockups": "Maquettes",
          "options": "Options",
          "locations": "Emplacements",
          "logistic": "Logistique",
          "review": "Vérification",
          "pricing": "Tarifs",
          "tiktok": "TikTok Shop",
          "areas": "Zones",
          "accessories": "Accessoires"
        },
        "blockSubtitles": {
          "techniques": "Configurez la technique de production de ce blueprint.",
          "options": "Sélectionnez des options pour générer les combinaisons de SKU. Maximum 3 options par blueprint.",
          "locations": "Configurez les lieux de fabrication et affectez les vendeurs de ce blueprint.",
          "logistic": "Configurez l’expédition et les frais de chaque SKU par emplacement.",
          "review": "Vérifiez le tout avant d’enregistrer.",
          "pricing": "Configurez les tarifs et les modèles de chaque SKU par emplacement.",
          "tiktok": "Paramètres TikTok Shop facultatifs pour ce blueprint.",
          "areas": "Configuration tarifaire des zones d’impression/broderie",
          "accessories": "Configurez les tarifs des accessoires et articles complémentaires."
        },
        "dimensionModal": {
          "aria": "Définir les dimensions",
          "title": "Définir les dimensions",
          "subtitle": "Configurez les dimensions du colis pour le calcul d’expédition.",
          "unitBox": "Poids du colis",
          "boxHeight": "Hauteur du colis",
          "boxWidth": "Largeur du colis",
          "boxLength": "Longueur du colis",
          "bulkTarget": "{{count}} SKU sélectionnés"
        },
        "countryTabsAria": "Pays",
        "countryTabsEmpty": "Ajoutez un emplacement dans le bloc Emplacements pour configurer les tarifs par pays.",
        "areas": {
          "selectionMode": "Mode de sélection",
          "mode": {
            "multi": "Choix multiple",
            "single": "Choix unique"
          },
          "startChargingFrom": "Facturer à partir de",
          "startChargingHint": "Le tarif s’applique à partir de cette zone. Ne peut être inférieur à la quantité requise.",
          "clampedToRequired": "Relevé à {{value}} — ce nombre de zones est requis, et une zone requise n’est jamais gratuite.",
          "pricingConfig": "Configuration tarifaire des zones",
          "applySameFee": "Même prix pour tous les paliers",
          "emptyNeedsTemplate": "Aucune zone d’impression. Les zones proviennent des modèles affectés à vos SKU — affectez un modèle dans le bloc Tarifs et elles apparaîtront ici.",
          "bulkEdit": "Modifier",
          "bulkEditAria": "Modifier les prix de plusieurs zones",
          "bulkEditSubtitle": "Modifier les prix de plusieurs zones à la fois.",
          "bulkPrice": "Prix",
          "bulkRequired": "Obligatoire",
          "bulkDisplay": "Affichage",
          "bulkEditDone": "{{count}} zone(s) mise(s) à jour.",
          "startChargingRequired": "« Facturer à partir de » est obligatoire — saisissez 1 ou plus."
        },
        "accessories": {
          "pricingConfig": "Configuration tarifaire des accessoires",
          "searchPlaceholder": "Rechercher des accessoires à ajouter...",
          "searching": "Recherche…",
          "noResults": "Aucun accessoire ne correspond.",
          "add": "Ajouter",
          "added": "Ajouté",
          "emptySearchToAdd": "Aucun accessoire lié. Utilisez la recherche ci-dessus.",
          "scopeFilter": "Rechercher les accessoires par",
          "scope": {
            "product": "Blueprint",
            "variant": "Variante"
          }
        },
        "breadcrumbAria": "Fil d’Ariane",
        "crumbBlueprint": "Blueprint",
        "crumbCreate": "Créer",
        "chargeForEmbroidery": {
          "yes": "Oui",
          "no": "Non"
        },
        "maxEmbroideryColors": {
          "invalid": "Le nombre maximal de couleurs de broderie doit être un entier supérieur à 0."
        },
        "toc": {
          "pinTitle": "Épingler la barre de sections au défilement",
          "unpinTitle": "Détacher la barre de sections"
        },
        "tocLabels": {
          "mockups": "Maquette"
        }
      }
    },
    "errors": {
      "missingTechnique": "Le blueprint doit avoir au moins une technique",
      "duplicateName": "Un blueprint avec ce nom existe déjà",
      "loadFailed": "Échec du chargement des blueprints",
      "networkError": "Erreur réseau",
      "networkErrorDesc": "Erreur réseau - vérifiez la connexion",
      "exportFailed": "Échec de l'export"
    },
    "detailPage": {
      "loading": "Chargement du blueprint…",
      "errorHeading": "Détail du blueprint",
      "backToList": "Retour aux Blueprints",
      "pricingSummary": "Appliquer {{amount}} $ à {{count}} variante(s) @ {{tier}}",
      "defaultTier": {
        "standard": "Standard",
        "premium": "Premium",
        "enterprise": "Entreprise"
      },
      "errors": {
        "missingId": "Identifiant de blueprint manquant dans l'URL",
        "loadFailedHttp": "Échec du chargement (HTTP {{status}})",
        "networkCheck": "Erreur réseau — vérifiez la connexion",
        "network": "Erreur réseau",
        "notFound": "Blueprint introuvable"
      },
      "header": {
        "code": "Code :",
        "slug": "Slug :",
        "status": "Statut :"
      },
      "actions": {
        "viewHistory": "Voir l'historique",
        "edit": "Modifier",
        "cancel": "Annuler",
        "delete": "Supprimer",
        "deleting": "Suppression…",
        "deleteTitle": "Suppression logique de ce blueprint (uniquement si Inactive)",
        "putOnSale": "Mettre en vente",
        "takeOffSale": "Retirer de la vente",
        "saving": "Enregistrement…",
        "saveAsDraft": "Enregistrer en brouillon",
        "saveChange": "Enregistrer les modifications",
        "goBack": "‹ Retour",
        "continue": "Continuer ›"
      },
      "confirm": {
        "deleteBlueprint": "Supprimer le blueprint « {{name}} » ? Il s'agit d'une suppression logique, restaurable depuis l'historique d'audit.",
        "removeVendorMapping": "Retirer ce mapping de fournisseur ?"
      },
      "toast": {
        "httpStatus": "HTTP {{status}}",
        "invalidPriceTitle": "Prix invalide",
        "invalidPriceDesc": "Saisissez un nombre ≥ 0 (ex. 19.99)",
        "csvEmptyTitle": "Excel vide",
        "csvEmptyDesc": "Aucune ligne de données.",
        "csvInvalidTitle": "Format Excel invalide",
        "csvMissingSku": "Colonne SKU manquante.",
        "importDoneTitle": "Import : {{count}} SKU mis à jour",
        "importPriceChanged": "Prix modifiés — appuyez sur Enregistrer les modifications pour sauvegarder (enregistré automatiquement).",
        "importTemplatesChanged": "Templates mis à jour dans la grille — appuyez sur Enregistrer les modifications pour sauvegarder.",
        "importShippingChanged": "Frais d'expédition mis à jour dans la grille — appuyez sur Enregistrer les modifications pour sauvegarder.",
        "importStatusChanged": "Statut mis à jour.",
        "logisticExportDone": "{{count}} lignes logistiques exportées",
        "logisticExportFailed": "Échec de l'export logistique",
        "logisticImportFormat": "Fichier non reconnu — exportez d'abord la feuille logistique, remplissez-la puis réimportez.",
        "logisticImportWrongLocation": "Cette feuille concerne {{sheet}}, mais l'onglet ouvert est {{active}}. Changez d'onglet puis réimportez.",
        "logisticImportNoMatch": "Aucun SKU correspondant — exportez d'abord le modèle, remplissez-le puis réimportez.",
        "logisticImportDone": "{{updated}} mises à jour, {{skipped}} ligne(s) logistique(s) ignorée(s) — Enregistrez pour appliquer",
        "logisticImportFailed": "Échec de l'import logistique — vérifiez que le fichier correspond au format exporté",
        "importShippingInvalid": "Frais d'expédition ignorés dans : {{columns}} — doit être un nombre entre 0 et 10000.",
        "pricingChangeFailed": "Échec du changement de prix",
        "pricingUpdatedTitle": "Prix mis à jour",
        "pricingUpdatedDesc": "Entrée du journal d'audit enregistrée.",
        "cannotDeleteTitle": "Suppression impossible",
        "cannotDeleteDesc": "Le blueprint doit être Inactive avant suppression.",
        "deleteFailed": "Échec de la suppression",
        "blueprintDeleted": "Blueprint supprimé",
        "cannotSaveTitle": "Enregistrement impossible",
        "cannotSaveImages": "Au moins 5 images mockup sont requises.",
        "saveFailed": "Échec de l'enregistrement",
        "blueprintSaved": "Blueprint enregistré",
        "loadVendorsFailed": "Échec du chargement des fournisseurs",
        "missingSelectionTitle": "Sélection manquante",
        "missingSelectionDesc": "Choisissez un fournisseur et une variante avant d'ajouter le mapping.",
        "addVendorFailed": "Échec de l'ajout du fournisseur",
        "vendorMappingAdded": "Mapping de fournisseur ajouté",
        "removeFailed": "Échec du retrait",
        "vendorMappingRemoved": "Mapping de fournisseur retiré",
        "statusChangeFailed": "Échec du changement de statut",
        "statusNoTransition": "Le statut « {{status}} » n’a pas de transition directe ici — un produit en attente d’approbation passe par la file de validation.",
        "statusChanged": "Statut → {{status}}",
        "savePublishFieldsFailed": "Échec de l'enregistrement des champs de publication",
        "publishingFieldsSaved": "Champs de publication enregistrés",
        "saveSeoFailed": "Échec de l'enregistrement du SEO",
        "seoSaved": "SEO enregistré",
        "linkAddonFailed": "Échec de l'association du complément",
        "addonLinkedTitle": "Complément associé",
        "addonLinkedDesc": "{{name}} a été assigné au produit.",
        "removeAddonFailed": "Échec du retrait du complément",
        "addonRemoved": "Complément retiré",
        "savePrintAreasFailed": "Échec de l'enregistrement des zones d'impression",
        "printAreasSaved": "Zones d'impression enregistrées",
        "reApprovalTitle": "Enregistré — produit retiré de la vente",
        "reApprovalDesc": "Cette modification renvoie le produit en validation ; les marchands ne peuvent plus le commander jusqu'à approbation. Modifié : {{fields}}.",
        "reApprovalResubmitTitle": "Enregistré — soumis à nouveau",
        "reApprovalResubmitDesc": "Le produit avait été refusé ; cette modification le remet dans la file de validation. Modifié : {{fields}}.",
        "step1IncompleteTitle": "L’étape 1 est incomplète",
        "step1ImagesDesc": "Au moins {{min}} images de maquette sont requises — vous en avez {{current}}.",
        "tierOrderTitle": "Paliers de prix dans le désordre",
        "tierOrderDesc": "{{current}} n’est pas inférieur à {{higherTier}} ({{higherValue}}). Un palier inférieur doit coûter moins que celui au-dessus.",
        "locationNeedsVendor": "L'emplacement « {{locations}} » n'a aucun vendeur. Choisissez-en un ou retirez l'emplacement avant d'enregistrer.",
        "vendorSplitInvalid": "La somme des parts des vendors en % doit être égale à 100 %.",
        "vendorSplitUnbound": "Un lieu attribue encore une part à un vendeur non sélectionné — ressaisissez les pourcentages.",
        "importSkuDataChanged": "Petit / dimensions mis à jour dans la grille — cliquez sur Save Change pour enregistrer."
      },
      "info": {
        "blueprintName": "Nom du blueprint",
        "blueprintCode": "Code du blueprint",
        "locked": "(verrouillé)",
        "slug": "Slug",
        "category": "Catégorie",
        "selectCategory": "Sélectionner une catégorie...",
        "collections": "Collections",
        "noCollections": "Aucune collection.",
        "productionType": "Type de production",
        "derivedFromTechniques": "Type de production enregistré : {{types}} — déduit des techniques ci-dessus.",
        "derivedReadOnly": "(dérivé, lecture seule)",
        "technology": "Technologie",
        "processingTime": "Temps de traitement",
        "to": "à",
        "days": "jours",
        "publishTime": "Heure de publication",
        "tags": "Tags (séparés par des virgules)",
        "description": "Description",
        "guideline": "Guide",
        "videoUrl": "URL vidéo",
        "videoUrlPlaceholder": "https://youtube.com/watch?v=..."
      },
      "seo": {
        "heading": "SEO",
        "title": "Titre",
        "metaDescription": "Meta description",
        "canonicalUrl": "URL canonique",
        "canonicalUrlError": "canonicalUrl doit commencer par http:// ou https://",
        "googleIndex": "Index Google",
        "indexInherit": "(hériter)",
        "indexYes": "index (oui)",
        "indexNo": "noindex (non)",
        "metaKeywords": "Mots-clés meta (séparés par des virgules, max 20)",
        "canonicalUrlPlaceholder": "https://…"
      },
      "images": {
        "label": "Images",
        "editHint": "Cliquez sur Modifier en haut de la page pour téléverser / modifier les images.",
        "dragDrop": "Glissez-déposez les images ici, ou",
        "uploadAria": "Téléverser des images mockup",
        "uploading": "Téléversement…",
        "uploadButton": "Téléverser des images",
        "acceptHint": "JPEG / PNG — jusqu'à 10 images, 5+ requises pour publier.",
        "moreNeeded": "{{count}} image(s) de plus requise(s) avant l'ouverture de la publication.",
        "mockup": "Mockup",
        "reorderHint": "L'image n°1 est la miniature (affichée dans la liste + la vitrine). Glissez pour réordonner.",
        "mockupAlt": "Mockup {{index}}",
        "thumb": "Miniature",
        "remove": "Retirer",
        "emptyTitle": "Aucune image téléversée",
        "emptyHint": "Les miniatures apparaîtront ici",
        "requiredError": "Au moins {{min}} images de maquette sont requises pour continuer — vous en avez {{current}}.",
        "viewImage": "Voir l’image mockup {{index}}",
        "viewerAria": "Aperçu de l’image mockup"
      },
      "attributes": {
        "bindingSummary": "{{locCount}} empl. · {{vendorCount}} fournisseur",
        "notAssigned": "Non assigné",
        "heading": "Attributs",
        "addOnlyHint": "Ajoutez une option ou une valeur pour créer plus de SKU. Les valeurs déjà utilisées par des SKU existants ne peuvent pas être supprimées.",
        "newSkuNote": "{{added}} nouveaux SKU seront créés à l'enregistrement ({{total}} au total). Renseignez ensuite leurs prix dans le bloc Pricing.",
        "lockedHint": "SKU / attributs / matrice de variantes verrouillés (immuables après création).",
        "options": "Options",
        "optionsSummary": "{{skuCount}} SKU · {{bindingCount}} liaison(s) d'option"
      },
      "locationVendor": {
        "heading": "Emplacement & Fournisseur",
        "removeHint": "Retirer un fournisseur : les commandes en cours se terminent dessus ; les nouvelles commandes non assignées ne seront pas routées vers le fournisseur retiré (flux pending_reassignment dans Order).",
        "noBindingEditable": "Aucun emplacement lié. Cliquez sur « + Ajouter un emplacement ».",
        "noBinding": "Aucun emplacement lié.",
        "location": "Emplacement",
        "defaultParen": "(par défaut)",
        "vendors": "Fournisseurs",
        "noVendor": "Aucun fournisseur assigné",
        "defaultStarTitle": "★ = fournisseur par défaut",
        "selectLocation": "— Sélectionner un emplacement —",
        "removeLocation": "Retirer l'emplacement",
        "radioDefault": "(radio = par défaut)",
        "selectVendor": "Sélectionner un fournisseur…",
        "removeVendor": "Retirer le fournisseur",
        "addVendor": "+ Ajouter un fournisseur",
        "defaultLocation": "Emplacement par défaut",
        "addLocation": "+ Ajouter un emplacement",
        "shareWithoutVendor": "non sélectionné — détient encore une part"
      },
      "sku": {
        "listTitle": "Liste des SKU",
        "listSubtitle": "{{count}} SKU · attributs verrouillés, les changements de prix nécessitent une raison",
        "bulkEditHint": "Édition en masse : téléchargez le Template → remplissez la colonne Templates (codes, plusieurs séparés par |) + le prix par palier → Import → Enregistrer les modifications.",
        "templateBtn": "Template",
        "templateBtnTitle": "Télécharger le template Excel (SKU pré-rempli, remplissez templates + prix puis Import)",
        "exportBtn": "Export",
        "exportBtnTitle": "Télécharger un Excel des données actuelles",
        "importBtn": "Import",
        "filterBy": "Filtrer par :",
        "noAttributeGroups": "Aucun groupe d'attributs.",
        "selectedCount": "{{count}} SKU sélectionné(s)",
        "templateLabel": "Template :",
        "assignTemplates": "Assigner des templates",
        "vendorLabel": "Fournisseur :",
        "assignVendorLocation": "Assigner fournisseur/emplacement",
        "priceLabel": "Prix :",
        "bulkEditPrices": "Modifier les prix en masse",
        "deselect": "Désélectionner",
        "selectAll": "Sélectionner tous les SKU",
        "colSkuCode": "Code SKU",
        "colAttributes": "Attributs",
        "colTemplates": "Templates",
        "colVendorLocation": "Fournisseur / Emplacement",
        "selectRow": "Sélectionner le SKU {{sku}}",
        "removeTemplateAria": "Retirer le template {{template}} de {{sku}}",
        "editTemplatesAria": "Modifier les templates de ce SKU",
        "splitTitle": "Commande répartie selon le % configuré",
        "editVendorAria": "Modifier fournisseur/emplacement de ce SKU",
        "footerNote": "Ajouter une option ou une valeur crée de nouveaux SKU à l'enregistrement ; les valeurs utilisées ne peuvent pas être supprimées. Le stock est géré sur la page Stock dédiée.",
        "allOptions": "Toutes les options",
        "clearFilters": "Effacer",
        "filterNoMatch": "Aucun SKU ne correspond à ce filtre.",
        "exportExcel": "Exporter Excel",
        "importExcel": "Importer Excel"
      },
      "priceLoc": {
        "label": "Prix par emplacement",
        "badgeTitle": "Onglet base = prix appliqué à tous les emplacements (par défaut). Autres onglets d'emplacement = prix spécifique à cet emplacement (remplace base). Enregistré via Enregistrer les modifications.",
        "badge": "base + override par emplacement · enregistré via Enregistrer les modifications",
        "baseSuffix": "(base)",
        "bulk": "En masse :",
        "copyFrom": "Copier le prix depuis l'emplacement…"
      },
      "logistics": {
        "colSku": "SKU",
        "colWeight": "Poids (g)",
        "colDimensions": "L×l×H (cm)"
      },
      "preview": {
        "information": "Informations",
        "blueprintCode": "Code du blueprint",
        "nameEn": "Nom (EN)",
        "slug": "Slug",
        "category": "Catégorie",
        "collections": "Collections",
        "productionTypes": "Types de production",
        "processingTime": "Temps de traitement",
        "daysRange": "{{from}}–{{to}} jours",
        "tags": "Tags",
        "images": "Images",
        "status": "Statut",
        "skusHeading": "SKU ({{count}})",
        "skusNote": "{{count}} variante(s). Modifiez prix / logistique dans les étapes précédentes, puis appuyez sur Enregistrer les modifications.",
        "imageWarning": "⚠ Nombre d'images {{count}}/5 — 5+ images requises avant l'enregistrement.",
        "editHint": "Cliquez sur « Edit » en haut de la page pour modifier.",
        "noSkus": "Aucun SKU généré pour le moment."
      },
      "addons": {
        "heading": "Compléments",
        "description": "Fonctionnalité optionnelle. Activez pour assigner des compléments partagés au produit (un complément peut être assigné à plusieurs blueprints).",
        "enable": "Activer les compléments",
        "disabledHint": "Compléments désactivés. Activez le toggle pour sélectionner des compléments pour le produit.",
        "addLabel": "Ajouter un complément",
        "noMore": "— Plus aucun complément à associer —",
        "selectAddon": "— Sélectionner un complément —",
        "requiredSuffix": ", requis",
        "saving": "Enregistrement…",
        "add": "Ajouter",
        "loading": "Chargement des compléments…",
        "empty": "Aucun complément assigné à ce produit pour l'instant.",
        "colName": "Nom",
        "colMode": "Mode",
        "colRequired": "Requis",
        "colStatus": "Statut",
        "colActions": "Actions",
        "yes": "Oui",
        "no": "Non",
        "remove": "Retirer",
        "footerNoteBefore": "Créez de nouveaux compléments sur la page ",
        "footerNoteAfter": ". Ici, vous assignez uniquement les compléments existants."
      },
      "accessoryLinks": {
        "title": "Accessoires liés",
        "subtitle": "Liez les produits accessoires vendus avec ce blueprint. Achetés ensemble, un accessoire ne facture ses frais de port supplémentaires que si l'option est activée ; les achats indépendants paient toujours les frais de port complets.",
        "addLabel": "Lier un accessoire",
        "selectAccessory": "— Sélectionner un accessoire —",
        "add": "Lier",
        "empty": "Aucun accessoire lié à ce blueprint pour le moment.",
        "colName": "Accessoire",
        "colChoiceMode": "Choix",
        "colRequired": "Requis",
        "colChargeFromN": "Facturer dès",
        "colMinMax": "Qté Min–Max",
        "colChargeShipping": "Port groupé",
        "colActions": "Actions",
        "chargeShippingHint": "Facturer les frais de port supplémentaires en cas d'achat groupé",
        "choiceMulti": "Multiple",
        "choiceSingle": "Unique",
        "min": "Min",
        "max": "Max",
        "applyAll": "Appliquer à tous les compléments",
        "applyAllHint": "Une configuration commune est appliquée à chaque accessoire lié à l'enregistrement. Désactivez pour configurer chacun indépendamment.",
        "maxAddons": "Compléments max / commande",
        "unlimited": "Illimité",
        "remove": "Retirer"
      },
      "vendorModal": {
        "title": "Ajouter un mapping de fournisseur",
        "description": "Choisissez un fournisseur + une variante de ce blueprint pour établir le mapping.",
        "vendor": "Fournisseur",
        "searchVendors": "Rechercher des fournisseurs par nom…",
        "variant": "Variante",
        "pickVariant": "— Choisir une variante —",
        "adding": "Ajout…",
        "add": "Ajouter"
      },
      "statusModal": {
        "aria": "Confirmer le changement de statut",
        "title": "Confirmer le changement de statut",
        "description": "Changer le statut du blueprint de {{from}} à {{to}} ?",
        "confirm": "Confirmer"
      },
      "templatePicker": {
        "inactiveBadge": "Inactif"
      },
      "vendorPicker": {
        "aria": "Assigner fournisseur/emplacement au SKU",
        "skuFallback": "SKU",
        "titleScoped": "Fournisseur — {{label}} · {{sku}}",
        "titleBulk": "Fournisseur / Emplacement — {{count}} SKU",
        "titleSingle": "Fournisseur / Emplacement — {{sku}}",
        "descScoped": "Choisissez fournisseur + % pour cet emplacement (emplacement = onglet actif). Total % = 100 pour répartir les commandes ; laisser vide = le routage choisit le fournisseur le mieux noté. Enregistré avec le bouton Enregistrer les modifications.",
        "descGeneral": "Assignez emplacement + fournisseur au SKU. La colonne % répartit par emplacement : le total de chaque emplacement = 100 pour répartir les commandes proportionnellement ; laisser vide = le routage choisit le fournisseur le mieux noté. Enregistré avec le bouton Enregistrer les modifications.",
        "emptyLocations": "Aucun emplacement. Cliquez sur + Ajouter un emplacement pour commencer.",
        "default": "Par défaut",
        "vendor": "Fournisseur",
        "orderPct": "% des commandes",
        "noVendorHint": "Aucun fournisseur. Cliquez sur « + Ajouter un fournisseur ».",
        "selectLocationFirst": "Sélectionnez d'abord un emplacement",
        "sumNoSplitTitle": "Pas de répartition — le routage choisit le fournisseur le mieux noté",
        "sumValidTitle": "Valide — réparti par %",
        "sumInvalidTitle": "Le total % de cet emplacement doit = 100 (ou tout laisser vide)",
        "needHundredSuffix": " — doit = 100",
        "warnTitle": "Chaque emplacement doit totaliser % = 100, ou tout laisser vide (pas de répartition). Impossible d'appliquer tant qu'un emplacement est incomplet.",
        "warnText": "{{count}} emplacement(s) sous 100 % — enregistrement impossible",
        "okTitle": "Tous les emplacements ont un % valide (=100)",
        "okText": "% valide — réparti par emplacement",
        "apply": "Appliquer",
        "applyBulk": "Appliquer ({{count}})",
        "applyInvalidTitle": "Le % d'un emplacement est invalide (≠100 et ≠0) — réglez-le à 100 ou effacez tous les %"
      },
      "bulkPrice": {
        "aria": "Modifier les prix en masse",
        "title": "Modifier les prix en masse — {{count}} SKU",
        "description": "Saisissez le prix (USD) pour le palier à modifier. Un palier à la fois — appuyer sur Appliquer demandera une raison.",
        "pricePlaceholder": "USD (ex. 19.99)",
        "apply": "Appliquer",
        "tierOrderHint": "Doit être inférieur au palier au-dessus."
      },
      "logistic": {
        "exportHint": "Télécharger la logistique (.xlsx) : SKU, poids, dimensions avec unités et frais de port par service ($).",
        "importHint": "Importer un .xlsx/.csv pour mettre à jour en masse le poids, les dimensions (avec unités) et les frais de port, appariés par SKU."
      }
    },
    "list": {
      "heading": "Blueprints",
      "subtitle": "Gérez vos configurations de blueprint et vos flux de publication.",
      "loading": "Chargement des blueprints…",
      "empty": "Aucun blueprint trouvé",
      "rowActionsAria": "Actions de la ligne",
      "vendorCountOne": "{{count}} fournisseur",
      "vendorCountOther": "{{count}} fournisseurs",
      "vendorModalAria": "Fournisseurs du blueprint",
      "vendorModalTitle": "Fournisseurs — {{name}}",
      "vendorModalDescOne": "{{count}} fournisseur fournit ce blueprint.",
      "vendorModalDescOther": "{{count}} fournisseurs fournissent ce blueprint.",
      "vendorModalNote": "La liste détaillée des fournisseurs se trouve sur la page de détail du blueprint. Cette fenêtre récapitulative n'affiche que le nombre total de fournisseurs.",
      "statusToggleAria": "Basculer le statut de {{name}}",
      "statusToggleOk": "Statut mis à jour",
      "statusToggleFailed": "Impossible de changer le statut",
      "activateTitle": "Mettre ce produit en vente ?",
      "deactivateTitle": "Retirer ce produit de la vente ?",
      "activateDesc": "« {{name}} » passe en Active et apparaît dans le catalogue de tous les marchands. La publication exige un poids et des dimensions sur chaque SKU.",
      "deactivateDesc": "« {{name}} » passe en Inactive et disparaît immédiatement du catalogue de tous les marchands. Les commandes déjà passées ne sont pas affectées.",
      "activateConfirm": "Mettre en vente",
      "deactivateConfirm": "Retirer de la vente",
      "cancel": "Annuler",
      "onSale": "En vente",
      "offSale": "Retiré",
      "awaitingApproval": "En attente de validation →",
      "close": "Fermer",
      "exportStarted": "Export démarré",
      "exportStartedDesc": "Le téléchargement devrait commencer sous peu.",
      "stats": {
        "totalBlueprints": "Total blueprints",
        "published": "Publiés",
        "draft": "Brouillon",
        "totalSkus": "Total SKU",
        "categories": "Catégories",
        "printAreas": "Zones d'impression"
      },
      "searchPlaceholder": "Rechercher des blueprints...",
      "searchAria": "Rechercher des blueprints",
      "filterPublishStatusAll": "Statut de publication",
      "filterPublishStatusAria": "Filtrer par statut de publication",
      "filterCreatorAll": "Créateur",
      "filterCreatorAria": "Filtrer par créateur",
      "filterStatusAll": "Statut",
      "filterStatusAria": "Filtrer par statut",
      "filterClearHint": "Cliquez à nouveau pour retirer ce filtre",
      "statusActive": "Actif",
      "statusInactive": "Inactif",
      "statusDraft": "Brouillon",
      "statusPendingApproval": "En attente d’approbation",
      "colBlueprint": "Blueprint",
      "colProcessingTime": "Délai de traitement",
      "colPublishStatus": "Statut de publication",
      "colPublishTime": "Date de publication",
      "colStatus": "Statut",
      "colCreator": "Créateur",
      "colCreatedDate": "Date de création",
      "colLastUpdate": "Dernière mise à jour",
      "colUpdatedBy": "Mis à jour par",
      "colAction": "Action",
      "selectAllAria": "Sélectionner tous les blueprints de cette page",
      "selectRowAria": "Sélectionner {{name}}",
      "editAria": "Modifier {{name}}",
      "configureSeoAria": "Configurer le SEO de {{name}}",
      "actionEdit": "Modifier",
      "actionConfigureSeo": "Configurer le SEO",
      "bulkSelectedOne": "{{count}} SKU sélectionné",
      "bulkSelectedOther": "{{count}} SKU sélectionnés",
      "bulkClearAria": "Effacer la sélection",
      "rowsPerPage": "Lignes par page :",
      "showingRange": "Affichage de {{from}} à {{to}} sur {{total}} blueprints",
      "prevPage": "Page précédente",
      "nextPage": "Page suivante",
      "paginationAria": "Pagination des blueprints",
      "loadError": "Impossible de charger les blueprints.",
      "retry": "Réessayer",
      "working": "Traitement…",
      "statusUpdated": "Statut mis à jour",
      "statusUpdatedDesc": "{{name}} est maintenant {{status}}.",
      "statusUpdateFailed": "Impossible de mettre à jour le statut",
      "duplicated": "Blueprint dupliqué",
      "duplicatedDesc": "{{code}} créé comme copie brouillon.",
      "duplicatedManyDesc": "{{count}} copies brouillon créées.",
      "duplicateFailed": "Duplication impossible",
      "publishStatus": {
        "Published": "Publié",
        "Draft": "Brouillon",
        "Unpublished": "Non publié",
        "Pending": "En attente"
      },
      "seoModal": {
        "heading": "Paramètres SEO",
        "subtitle": "Optimisez l'affichage de « {{name}} » dans les moteurs de recherche.",
        "loading": "Chargement des paramètres SEO…",
        "loadFailed": "Impossible de charger les paramètres SEO de ce blueprint.",
        "titleLabel": "Titre SEO",
        "titlePlaceholder": "Saisir le titre SEO",
        "titleHelper": "Si laissé vide, le système peut utiliser l'alias automatiquement.",
        "canonicalLabel": "URL canonique",
        "canonicalPlaceholder": "https://example.com/blueprint/...",
        "canonicalHelper": "URL préférée des moteurs de recherche pour éviter le contenu dupliqué.",
        "googleIndexLabel": "Index Google",
        "keywordsLabel": "Mots-clés meta",
        "keywordsPlaceholder": "Saisir un mot-clé puis appuyer sur Entrée",
        "keywordRemove": "Supprimer le mot-clé {{keyword}}",
        "descriptionLabel": "Meta description",
        "descriptionPlaceholder": "Saisir un résumé court pour les moteurs de recherche...",
        "descriptionHelper": "Longueur recommandée : 150–160 caractères.",
        "descriptionCounter": "{{count}} / {{max}} caractères",
        "cancel": "Annuler",
        "save": "Enregistrer",
        "saved": "Paramètres SEO enregistrés",
        "saveFailed": "Impossible d'enregistrer les paramètres SEO",
        "reApprovalHint": "Ce blueprint est Actif. Enregistrer des modifications SEO le renvoie en validation : les marchands ne pourront plus le commander avant une nouvelle approbation.",
        "reApprovalTitle": "Enregistré — produit retiré de la vente",
        "reApprovalDesc": "Cette modification renvoie le produit en validation ; les marchands ne peuvent plus le commander avant approbation. Modifié : {{fields}}.",
        "reApprovalResubmitTitle": "Enregistré — soumis à nouveau",
        "reApprovalResubmitDesc": "Le produit avait été refusé ; cette modification le remet dans la file de validation. Modifié : {{fields}}.",
        "errors": {
          "titleTooLong": "Le titre SEO ne doit pas dépasser {{max}} caractères.",
          "canonicalInvalid": "L'URL canonique doit commencer par http:// ou https://.",
          "metaDescriptionTooLong": "La meta description ne doit pas dépasser {{max}} caractères."
        }
      }
    },
    "blankMethods": {
      "heading": "Méthodes Blank",
      "banner": "Produit blank — aucuns frais d'impression, de gravure ou de broderie. Un enregistrement \"Blank Product\" par défaut est créé automatiquement.",
      "toast": {
        "created": "Méthode blank créée",
        "createFailed": "Échec de la création",
        "createFailedTitle": "Échec de la création de la méthode blank",
        "deleted": "Méthode blank supprimée"
      },
      "codeAria": "Code (slug)",
      "codePlaceholder": "code (ex. blank-product)",
      "nameEnglish": "Nom affiché (anglais)",
      "addBtn": "Ajouter une méthode blank",
      "colCode": "Code",
      "empty": "Aucune méthode blank pour le moment — ajoutez-en une ci-dessus.",
      "toggleTitleOn": "Actif — cliquez pour désactiver",
      "toggleTitleOff": "Inactif — cliquez pour activer",
      "toggleAria": "Bascule actif pour {{code}}",
      "confirmDelete": "Supprimer la méthode blank \"{{code}}\" ?"
    },
    "listFilters": {
      "search": {
        "placeholder": "Rechercher blueprints, SKU ou catégorie…",
        "aria": "Rechercher des blueprints"
      },
      "status": {
        "aria": "Filtrer par statut",
        "all": "Tous les statuts",
        "pendingApproval": "En attente d'approbation"
      },
      "source": {
        "aria": "Filtrer par source",
        "all": "Toutes les sources",
        "admin": "Admin"
      },
      "clear": "Effacer"
    },
    "imagesSection": {
      "headerCountOne": "{{count}} image · minimum 5 requis",
      "headerCountOther": "{{count}} images · minimum 5 requis",
      "tooFew": "Au moins 5 images mockup sont requises avant de pouvoir enregistrer ce blueprint.",
      "bulkMax": "Maximum de 10 images déjà atteint.",
      "bulkFailed": "{{count}} échec(s)",
      "bulkSkipped": "{{count}} ignorée(s) (max 10)",
      "dragTitle": "Glisser pour réordonner l'image",
      "moveEarlier": "Déplacer l'image {{index}} vers le début",
      "moveLater": "Déplacer l'image {{index}} vers la fin",
      "removeImage": "Supprimer l'image {{index}}",
      "max10": "Max 10 images",
      "uploadOne": "+ Téléverser une image",
      "uploadMultiple": "+ Téléverser plusieurs",
      "pickerTitle": "Téléverser une image mockup"
    },
    "personalize": {
      "heading": "3. Personnalisation",
      "toggleOn": "Personnalisation : ON",
      "toggleOff": "Personnalisation : OFF",
      "intro": "Choisissez lesquelles des 19 zones de personnalisation fixes sont disponibles pour ce blueprint.",
      "zonesAria": "Zones de personnalisation",
      "zonesEnabled": "{{active}}/{{total}} zones activées",
      "disabled": "Personnalisation désactivée — grille des zones masquée.",
      "zones": {
        "front-center": "Centre avant",
        "front-left-chest": "Poitrine avant gauche",
        "front-right-chest": "Poitrine avant droite",
        "front-bottom": "Bas avant",
        "back-center": "Centre arrière",
        "back-upper": "Haut arrière",
        "back-bottom": "Bas arrière",
        "left-sleeve": "Manche gauche",
        "right-sleeve": "Manche droite",
        "collar": "Col",
        "hood-front": "Capuche avant",
        "hood-back": "Capuche arrière",
        "pocket-front": "Poche avant",
        "pocket-back": "Poche arrière",
        "cuff-left": "Poignet gauche",
        "cuff-right": "Poignet droit",
        "hem": "Ourlet",
        "side-left": "Côté gauche",
        "side-right": "Côté droit"
      }
    },
    "pricingSection": {
      "heading": "4. Tarification",
      "headerSummary": "{{variants}} variante(s) · {{tiers}} palier(s) · {{selected}} sélectionnée(s)",
      "bulkApplyNone": "Appliquer le prix en masse à aucune variante sélectionnée :",
      "bulkApplyOne": "Appliquer le prix en masse à {{count}} variante sélectionnée :",
      "bulkApplyOther": "Appliquer le prix en masse à {{count}} variantes sélectionnées :",
      "tierLabel": "Palier",
      "priceUsd": "Prix (USD)",
      "applyTierPrice": "Appliquer le prix du palier…",
      "auditReason": "Raison d'audit requise",
      "invalidPrice": "Saisissez un prix USD non négatif (ex. 19.99)",
      "colVariant": "Variante (SKU)",
      "selectAllAria": "Sélectionner toutes les variantes",
      "selectRowAria": "Sélectionner la variante {{sku}}",
      "empty": "Aucune variante — ajoutez-en depuis la section Variantes d'abord."
    },
    "importDialog": {
      "title": "Importer des blueprints",
      "description": "Téléversez un fichier XLSX multi-feuilles. Le serveur l'analysera, signalera les doublons, puis enregistrera les fiches.",
      "steps": {
        "upload": "1. Téléverser",
        "preview": "2. Aperçu",
        "confirm": "3. Confirmer"
      },
      "upload": {
        "intro": "Téléversez un fichier XLSX au modèle multi-feuilles standard (Metadata + Pricing). Le serveur l'analysera et signalera les avertissements de doublons avant l'enregistrement.",
        "downloadTemplate": "Télécharger le modèle",
        "selected": "Sélectionné :",
        "fileKb": "{{size}} Ko"
      },
      "preview": {
        "noData": "Aucune donnée d'aperçu.",
        "sheets": "Feuilles",
        "noSheets": "(aucune feuille détectée)",
        "rows": "{{count}} lignes",
        "duplicateDetection": "Détection des doublons",
        "noDuplicates": "Aucun blueprint similaire détecté.",
        "rowLabel": "Ligne {{row}} —",
        "score": "(score {{score}})"
      },
      "confirm": {
        "body": "Confirmez l'import du fichier ci-dessous. Appuyez sur « Confirmer » pour continuer."
      },
      "done": "Aperçu d'import accepté. Le point de terminaison d'enregistrement réel arrivera dans une prochaine étape ; cette boîte de dialogue peut maintenant être fermée.",
      "footer": {
        "uploadPreview": "Téléverser & aperçu",
        "confirming": "Confirmation…",
        "confirm": "Confirmer"
      },
      "toast": {
        "noFileTitle": "Aucun fichier sélectionné",
        "noFileDesc": "Veuillez choisir un fichier XLSX avant de continuer.",
        "previewFailed": "Échec de l'aperçu d'import",
        "unexpected": "Le serveur a renvoyé une réponse inattendue.",
        "previewedTitle": "Import prévisualisé",
        "previewedDesc": "Aperçu accepté. Le gestionnaire d'enregistrement arrivera dans une prochaine étape."
      }
    },
    "routing": {
      "modeMerchant": "Marchand",
      "modePercent": "%",
      "modeGroupAria": "Mode de répartition des commandes pour {{vendor}}",
      "defaultVendorAria": "Fournisseur par défaut {{vendor}}",
      "merchantPlaceholder": "Sélectionner des marchands",
      "merchantSearch": "Rechercher un marchand",
      "merchantSearching": "Recherche de marchands…",
      "merchantEmpty": "Aucun marchand trouvé",
      "errorMerchantEmpty": "Sélectionnez au moins un marchand",
      "errorMerchantDup": "{{merchant}} est déjà attribué à un autre fournisseur pour cet emplacement",
      "merchantLoadError": "Impossible de charger les marchands (permission user:read manquante)",
      "toastMerchantInvalid": "Certains fournisseurs en mode Marchand n’ont aucun marchand ou en partagent un avec un autre fournisseur."
    },
    "accessoryParents": {
      "title": "Blueprints utilisant cet accessoire",
      "searchPlaceholder": "Rechercher par nom ou code",
      "colImage": "Image",
      "colName": "Nom",
      "colCode": "Code",
      "colCategory": "Catégorie",
      "colStatus": "Statut",
      "empty": "Aucun blueprint ne lie cet accessoire",
      "loadFailed": "Impossible de charger les blueprints liés",
      "openInNewTab": "Ouvrir {{name}} dans un nouvel onglet",
      "close": "Fermer",
      "rowsPerPage": "Lignes par page",
      "range": "Affichage {{from}}–{{to}} sur {{total}}",
      "prevPage": "Page précédente",
      "nextPage": "Page suivante",
      "paginationAria": "Pagination des blueprints liés"
    },
    "accessoryOff": {
      "title": "Désactiver les accessoires ?",
      "body1": "Désactiver les accessoires convertira ce Blueprint en Blueprint standard et le retirera des listes d’accessoires de ces Blueprints.",
      "body2": "Voulez-vous vraiment continuer ?",
      "viewProducts": "Voir les produits",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "close": "Fermer"
    },
    "retail": {
      "label": "Vente au détail",
      "hint": "Afficher cet accessoire sur la page d’accueil et le vendre séparément",
      "disabledHint": "Activez Accessoires pour activer la vente au détail"
    }
  },
  "product_approval": {
    "title": "Approbation des produits",
    "subtitle": "Produits vendeurs en attente de revue",
    "columns": {
      "product": "Produit",
      "vendor": "Vendeur",
      "submittedAt": "Soumis le",
      "category": "Catégorie",
      "status": "Statut",
      "type": "Type",
      "actions": "Actions"
    },
    "status": {
      "pending": "En attente de revue",
      "approved": "Approuvé",
      "rejected": "Rejeté",
      "changesRequested": "Modifications demandées"
    },
    "actions": {
      "approve": "Approuver",
      "reject": "Rejeter",
      "requestChanges": "Demander des modifications",
      "viewDiff": "Voir les différences",
      "uploadExcel": "Importer Excel",
      "diff": "Diff",
      "details": "Détails",
      "cancel": "Annuler"
    },
    "fields": {
      "rejectionReason": "Motif du rejet",
      "changeNotes": "Notes de modification"
    },
    "pageSubtitle": "Approuvez les nouveaux produits et les modifications des vendeurs. La re-approbation s'applique à 5 champs : {{fields}}.",
    "types": {
      "newSubmission": "Nouvelle soumission",
      "reApproval": "Re-approbation",
      "adminSelfCreate": "Création par l'admin"
    },
    "filters": {
      "typeLabel": "Type",
      "statusLabel": "Statut",
      "sourceLabel": "Source",
      "allTypes": "Tous les types",
      "allStatuses": "Tous les statuts"
    },
    "source": {
      "all": "Toutes les sources",
      "vendorSelfSubmit": "Soumission du vendeur",
      "adminExcelUpload": "Import Excel admin"
    },
    "sourcePill": {
      "vendorSubmit": "Envoi vendeur",
      "adminUpload": "Import admin"
    },
    "summary": {
      "pendingLabel": "en attente",
      "totalLabel": "au total"
    },
    "bulk": {
      "selected": "{{count}} sélectionné(s)",
      "approve": "Approuver ({{count}})",
      "approving": "Approbation…",
      "reject": "Rejeter ({{count}})",
      "clear": "Tout désélectionner"
    },
    "table": {
      "selectAllAria": "Sélectionner tous les éléments en attente",
      "selectRowAria": "Sélectionner {{name}}",
      "loading": "Chargement…",
      "empty": "Aucun produit dans la file."
    },
    "links": {
      "viewVendorProduct": "Voir VendorProduct",
      "openBlueprint": "Ouvrir le détail du blueprint"
    },
    "applyTargets": "S'appliquera à {{count}} vendeur(s) à l'approbation",
    "duplicate": {
      "title": "{{count}} blueprints similaires détectés",
      "similarity": "(similarité {{pct}} %)"
    },
    "reject": {
      "title": "Rejeter — {{name}}",
      "bulkTitle": "Rejeter {{count}} produits",
      "hint": "Motif du rejet (10-500 caractères). Sera consigné dans le journal d'audit et envoyé au vendeur.",
      "placeholder": "Ex. : baseCost ne correspond pas au marché, veuillez vérifier et ajouter la shipping zone EU…",
      "counter": "{{count}} / 500 (minimum 10)",
      "submitting": "Envoi…",
      "confirm": "Confirmer le rejet",
      "errorLength": "Le motif doit comporter 10 à 500 caractères"
    },
    "override": {
      "title": "Dérogation 4-eyes — {{name}}",
      "bodyBefore": "Vous approuvez un blueprint que vous avez créé vous-même. Le rôle ",
      "bodyAfter": " permet de contourner la règle des 4-eyes, mais vous devez indiquer un motif clair pour le journal d'audit.",
      "reasonLabel": "Motif de la dérogation",
      "placeholder": "Exemple : un seul superadmin de service aujourd'hui, déjà revu avec la QA…",
      "hint": "1 à 2000 caractères. Le motif sera consigné dans le journal d'audit.",
      "submitting": "Envoi…",
      "confirm": "Confirmer la dérogation",
      "errorLength": "Le motif de dérogation doit comporter 1 à 2000 caractères"
    },
    "diff": {
      "loading": "Chargement du diff…"
    },
    "errors": {
      "generic": "Une erreur est survenue",
      "fourEyesRequired": "Vous ne pouvez pas approuver un blueprint que vous avez créé. Un autre administrateur doit l'approuver.",
      "overrideReasonRequired": "Un superadmin qui approuve son propre blueprint doit fournir une raison de dérogation.",
      "notReadyForPublish": "Ce blueprint n'est pas prêt à être publié — ajoutez les maquettes et zones d'impression manquantes avant d'approuver.",
      "blueprintNotFound": "Le blueprint référencé par cette demande n'existe plus.",
      "approvalNotFound": "Cette demande d'approbation est introuvable.",
      "alreadyResolved": "Cette soumission a déjà été traitée.",
      "categoryNotFound": "Aucune catégorie disponible pour rattacher le nouveau blueprint. Créez au moins une catégorie avant d'approuver.",
      "costGuard": "Le coût fournisseur n’est pas inférieur au prix marchand le plus bas pour certains SKU — voir la liste, puis refuser avec un motif.",
      "alreadyListed": "Ce fournisseur est déjà lié à l’un de ces SKU Printway via un autre produit.",
      "blueprintUnavailable": "Le produit Printway n’est pas actif (ou un SKU ne lui appartient plus).",
      "pricingMissing": "Un SKU Printway n’a pas encore de prix marchand — définissez d’abord les prix du blueprint.",
      "variantSpecOutOfRange": "Le délai de traitement (1–60 jours), la capacité (≥ 1/jour), le poids ou les dimensions (> 0) d’une variante sont hors limites — demandez au vendeur de corriger.",
      "withSkus": "{{reason}} — {{skus}}",
      "forProduct": "{{product}} : {{reason}}",
      "conflictRetry": "Une autre modification a touché cette demande en même temps. Rien n’a été enregistré — veuillez réessayer."
    },
    "toast": {
      "loadFailTitle": "Impossible de charger la liste",
      "unknownError": "Erreur inconnue",
      "approveFailed": "Échec de l'approbation",
      "approved": "Produit approuvé",
      "rejected": "Produit rejeté",
      "approvedCount": "Approuvé {{ok}}/{{total}}",
      "rejectedCount": "Rejeté {{ok}}/{{total}}",
      "failCount": "{{fail}} en échec."
    },
    "diffModal": {
      "title": "Diff de re-approbation",
      "empty": "Le vendeur n'a modifié aucun champ nécessitant une re-approbation (seulement description / images / tags). La re-approbation n'est pas nécessaire.",
      "col": {
        "field": "Champ",
        "previous": "Précédent",
        "new": "Nouveau"
      },
      "fields": {
        "processingTime": "Temps de traitement",
        "baseCost": "Coût de base",
        "capacityPerDay": "Capacité / jour",
        "shippingZones": "Zones d'expédition",
        "productionSpecs": "Spécifications de production",
        "cost_price_cents": "Coût de base",
        "variant_dimensions": "Dimensions",
        "variant_processing_time_days": "Temps de traitement (jours)",
        "variant_capacity_per_day": "Capacité / jour",
        "variant_weight_grams": "Poids (g)",
        "variant_cost_cents": "Coût (par SKU)",
        "variant_cost_markup_cents": "Majoration"
      },
      "actions": {
        "close": "Fermer"
      }
    },
    "uploadDialog": {
      "title": {
        "upload": "Importer l'Excel produit vendeur",
        "preview": "Aperçu — produits en attente de validation"
      },
      "fileLabel": "Fichier CSV/Excel",
      "selectVendorPlaceholder": "— Choisir un vendeur —",
      "vendorLoadFail": "Impossible de charger la liste des vendeurs. Rouvrez cette boîte de dialogue après avoir visité la page Vendeurs pour que le cache soit rempli.",
      "parsedRows": "{{count}} lignes analysées — vérifiez l'aperçu après l'import.",
      "applyLabel": "Appliquer le blueprint aux vendeurs (optionnel)",
      "applyHelp": "Lorsque l'admin approuve, le système crée 1 VendorProduct (state=\"live\") pour chaque vendeur sélectionné. Laisser vide = le blueprint va uniquement dans le catalogue partagé.",
      "applyVendorEmpty": "L'annuaire des vendeurs n'a pas encore de données — le sélecteur d'application est indisponible.",
      "applyCountNote": "Sera appliqué à {{count}} vendeurs lorsque l'admin approuve.",
      "previewSummary": "{{products}} produits, {{variants}} variantes. ID d'import :",
      "validationErrorsTitle": "Erreurs de validation ({{count}})",
      "errorRow": "Ligne {{row}}",
      "col": {
        "diffWarning": "Diff / avertissement"
      },
      "badgeNew": "Nouveau",
      "fieldsChanged": "{{count}} champs modifiés",
      "similarBlueprints": "{{count}} blueprints similaires",
      "uploading": "Import en cours…",
      "uploadPreview": "Importer + aperçu",
      "actions": {
        "close": "Fermer"
      },
      "parse": {
        "noRows": "Aucune ligne de données trouvée — vérifiez l'en-tête.",
        "readFail": "Impossible de lire le fichier : {{message}}",
        "readFailGeneric": "Impossible de lire le fichier Excel/CSV"
      },
      "toast": {
        "uploadFailedTitle": "Échec de l'import",
        "uploadedTitle": "Importé et analysé",
        "uploadedDesc": "{{products}} produits / {{variants}} variantes en attente de validation."
      }
    },
    "mapping": {
      "linksTo": "L’approbation lie ce fournisseur au produit Printway",
      "col": {
        "sku": "SKU Printway",
        "vendorLabel": "Taille / couleur fournisseur",
        "printwayLabel": "Taille / couleur Printway",
        "cost": "Coût fournisseur",
        "lowestTier": "Prix marchand le plus bas",
        "margin": "Marge"
      },
      "disabled": "désactivé",
      "labelMismatch": "libellé différent de Printway",
      "noPrice": "Pas de prix",
      "violationHint": "Lignes en rouge : le coût fournisseur n’est pas inférieur au prix marchand le plus bas — l’approbation sera refusée."
    },
    "confirmApprove": {
      "title": "Approuver cette demande ?",
      "bulkTitle_one": "Approuver {{count}} demande ?",
      "bulkTitle_other": "Approuver {{count}} demandes ?",
      "body_one": "L’approbation lie le fournisseur au produit Printway pour {{count}} SKU.",
      "body_other": "L’approbation lie le fournisseur au produit Printway pour {{count}} SKU.",
      "bulkBody_one": "Approuver {{count}} demande. Les produits mappés lient leur fournisseur au produit Printway.",
      "bulkBody_other": "Approuver {{count}} demandes. Les produits mappés lient leur fournisseur au produit Printway.",
      "routing": "Les SKU liés entrent dans le routage des commandes : sans allocation, ce fournisseur peut recevoir des commandes immédiatement selon son score.",
      "bodyGeneric": "Les produits fournisseur mappés lient leur fournisseur au produit Printway une fois approuvés.",
      "bulkBodySkus_one": "Approuver {{count}} demande — {{skus}} SKU entrent dans le pool de routage.",
      "bulkBodySkus_other": "Approuver {{count}} demandes — {{skus}} SKU entrent dans le pool de routage.",
      "loading": "Comptage des SKU à lier…",
      "loadFailed": "Impossible de charger le mapping des SKU"
    },
    "unmappedBadge": "Non mappé"
  },
  "products_special": {
    "title": "Produits spéciaux",
    "subtitle": "Attributions de produits mis en avant",
    "columns": {
      "product": "Produit",
      "tag": "Étiquette",
      "assignedAt": "Attribué le",
      "expiresAt": "Expire le",
      "blueprintCode": "Code blueprint",
      "name": "Nom",
      "variantAssignments": "Affectations de variantes",
      "merchants": "Marchands",
      "createdDate": "Date de création",
      "actions": "Actions",
      "productName": "NOM DU PRODUIT",
      "skuCount": "NOMBRE DE SKU",
      "assignedMerchants": "MARCHANDS ASSIGNÉS",
      "status": "STATUT",
      "action": "ACTION"
    },
    "actions": {
      "assign": "Attribuer",
      "unassign": "Retirer",
      "edit": "Modifier",
      "delete": "Supprimer"
    },
    "fields": {
      "tag": "Étiquette spéciale",
      "expiresAt": "Expire le"
    },
    "list": {
      "heading": "Produit spécial",
      "subtitle": "Gérez les produits spéciaux réservés à certains marchands.",
      "create": "Créer",
      "searchLabel": "Recherche",
      "searchPlaceholder": "Rechercher par nom de produit ou SKU...",
      "merchantMin": "Marchands min",
      "merchantMax": "Marchands max",
      "createdAfter": "Créé à partir du",
      "createdBefore": "Jusqu'au",
      "clearFilter": "Effacer les filtres",
      "totalCount": "{{count}} blueprint special",
      "selectedLabel": "blueprint special sélectionnés",
      "deselect": "Désélectionner",
      "deleting": "Suppression…",
      "deleteSelected": "Supprimer {{count}} lignes",
      "loading": "Chargement de Products Special…",
      "loadError": "Impossible de charger la liste : {{message}}",
      "empty": "Aucun produit spécial pour le moment.",
      "selectAllAria": "Sélectionner toutes les lignes de cette page",
      "selectRowAria": "Sélectionner {{code}}",
      "variantCount": "{{count}} variante",
      "allBlueprint": "Blueprint entier",
      "assignMerchantsOne": "{{count}} marchand →",
      "assignMerchantsOther": "{{count}} marchands →",
      "rowsLabel": "Lignes",
      "rowsPerPageAria": "Lignes par page",
      "bulkDeleted": "Supprimé en masse",
      "bulkDeletedPartial": "{{deleted}} supprimés, {{notFound}} introuvables",
      "bulkDeletedAll": "{{count}} blueprint special supprimés",
      "deleteFailed": "Échec de la suppression",
      "networkError": "Erreur réseau",
      "confirmBulkDelete": "Supprimer les {{count}} blueprint special sélectionnés ?",
      "deleted": "Produit spécial retiré",
      "confirmDelete": "Retirer « {{label}} » des produits spéciaux ? Le blueprint retourne au catalogue public.",
      "noVariantAssignment": "Aucune affectation de variante",
      "searchAria": "Rechercher des produits spéciaux",
      "filterStatusAll": "Statut : tous",
      "filterStatusAria": "Filtrer par statut",
      "working": "En cours…",
      "retry": "Réessayer",
      "rowsPerPage": "Lignes par page :",
      "showingRange": "Affichage de {{from}} à {{to}} sur {{total}} produits spéciaux",
      "paginationAria": "Pagination des produits spéciaux",
      "prevPage": "Page précédente",
      "nextPage": "Page suivante",
      "skuCount": "{{count}} SKU",
      "noMerchants": "Aucun marchand",
      "moreMerchants": "+{{count}} autres",
      "statusToggleAria": "Activer ou désactiver {{name}}",
      "editAria": "Modifier les marchands assignés à {{name}}",
      "deleteAria": "Retirer {{name}} des produits spéciaux",
      "statusActivated": "Produit spécial activé",
      "statusDeactivated": "Produit spécial désactivé",
      "statusFailed": "Impossible de changer le statut",
      "confirmDeleteTitle": "Retirer des produits spéciaux ?"
    },
    "detail": {
      "missingId": "ID manquant",
      "loading": "Chargement…",
      "loadError": "Échec du chargement des détails : {{message}}",
      "noData": "aucune donnée",
      "emptyResponse": "Réponse vide",
      "unknownError": "Erreur inconnue",
      "backToList": "← Retour à la liste",
      "blueprintMissing": "— blueprint manquant —",
      "codeLabel": "Code :",
      "assignmentIdLabel": "ID d'affectation :",
      "merchantsAssigned": "{{count}} marchands assignés",
      "createdAt": "Créé : {{date}}",
      "updatedAt": "Mis à jour : {{date}}",
      "blueprintCard": "Blueprint",
      "noTags": "Aucun tag",
      "blueprintDeleted": "Blueprint supprimé ou inexistant.",
      "blueprintLevelTitle": "Affectations de marchands au niveau blueprint",
      "noBlueprintAssignments": "Aucun marchand assigné au niveau blueprint.",
      "variantLevelTitle": "Affectations de marchands au niveau variante",
      "variantCol": "Variante",
      "statusCol": "Statut",
      "auditLogTitle": "Journal d'audit ({{count}})",
      "noAuditEntries": "Aucune entrée d'audit pour l'instant.",
      "actorLabel": "Acteur : {{actor}}",
      "viewGroupAria": "Mode d'affichage des affectations de variantes",
      "viewByVariant": "Par variante",
      "viewByMerchant": "Par marchand",
      "noVariantMerchantAssignments": "Aucune affectation de marchand au niveau variante pour l'instant.",
      "variantsForMerchant": "{{count}} variantes",
      "auditAction": {
        "create": "Ajouté aux Products Special",
        "update_assignments": "Attributions de marchands modifiées",
        "remove_blueprint": "Retiré des Products Special"
      },
      "assignMerchants": "Attribuer des marchands",
      "assignPerVariant": "Attribuer par SKU"
    },
    "attributesGenerator": {
      "labelPlaceholder": "-- Libellé --",
      "addAttribute": "+ Ajouter une option",
      "skuGeneratedOne": "{{count}} SKU généré — le tableau de droite se met à jour quand vous cochez des valeurs.",
      "skuGeneratedOther": "{{count}} SKU générés — le tableau de droite se met à jour quand vous cochez des valeurs.",
      "clearOption": "Effacer l'option",
      "searchOption": "Rechercher une option…",
      "removeAttribute": "Supprimer l'option",
      "loadingOptions": "Chargement des options…",
      "noOptionsForLabel": "Aucune option trouvée pour {{label}}",
      "noOptionsMatch": "Aucune option correspondante",
      "selectValues": "Sélectionner des valeurs…",
      "noActiveValues": "Aucune valeur active pour cette option.",
      "noValuesMatch": "Aucune valeur correspondante.",
      "maxReached": "Maximum de {{max}} options par blueprint atteint.",
      "columnOptionType": "Type d'option",
      "columnOptionName": "Nom de l'option",
      "columnOptionValues": "Valeurs de l'option",
      "pickOptionFirst": "Choisissez d'abord un nom d'option",
      "searchValues": "Rechercher des valeurs…",
      "removeValueAria": "Supprimer {{value}}",
      "valueLockedInUse": "Utilisée par des SKU existants — ajout possible, suppression non"
    },
    "giftMessagesTab": {
      "sectionAria": "Messages cadeau",
      "newTitle": "Nouveau modèle de message cadeau",
      "namePlaceholder": "Nom du modèle (EN)",
      "maxLengthPlaceholder": "Longueur max",
      "pricePlaceholder": "Prix (centimes)",
      "saving": "Enregistrement…",
      "submit": "Créer le modèle",
      "empty": "Aucun modèle — créez-en un ci-dessus.",
      "errTierRequired": "Un palier et un prix entier non négatif sont requis.",
      "toastCreated": "Modèle de message cadeau créé",
      "toastCreateFailed": "Échec de la création du modèle cadeau",
      "col": {
        "nameEn": "Nom (EN)",
        "maxLength": "Longueur max",
        "tierRows": "Lignes de palier",
        "firstTierPrice": "Prix du premier palier"
      }
    },
    "assignModal": {
      "saveSuccess": "Affectation enregistrée",
      "saveErrorTitle": "Impossible d'enregistrer l'affectation",
      "networkCheckError": "Erreur réseau — vérifiez la connexion",
      "title": "Affecter des marchands — {{name}}",
      "hint": "Grille au niveau des variantes. Les cases des variantes masquées sont désactivées.",
      "scopeGroupAria": "Portée de la liste des marchands",
      "scopeAssigned": "Affectés ({{count}})",
      "scopeAll": "Tous ({{count}})",
      "noAssignedYet": "Aucun marchand affecté. Passez à « Tous » pour en ajouter.",
      "noMerchants": "Aucun marchand dans le répertoire.",
      "merchantCol": "Marchand",
      "allVariantsTitle": "Activer/désactiver l'affectation pour TOUT le blueprint (toutes les variantes)",
      "allVariants": "Toutes les variantes",
      "hiddenVariantTitle": "Variante masquée — désactivée",
      "hiddenCheckboxTitle": "Impossible d'affecter une variante masquée",
      "cancel": "Annuler",
      "saving": "Enregistrement…",
      "save": "Enregistrer l'affectation",
      "scopeAllShort": "Tous les marchands",
      "searchPlaceholder": "Rechercher un marchand par nom ou e-mail…",
      "loadingMerchants": "Chargement des marchands…",
      "directoryError": "Impossible de charger le répertoire des marchands. Vérifiez votre connexion et réessayez.",
      "noSearchMatch": "Aucun marchand ne correspond à « {{term}} ».",
      "offscreenNote": "Les {{count}} marchands affectés sont tous enregistrés, y compris ceux absents de cette page.",
      "removeCol": "Retirer le marchand",
      "removeMerchantTitle": "Retirer {{name}} de ce produit",
      "removeConfirmTitle": "Retirer ce marchand ?",
      "removeConfirmDesc": "{{name}} ne pourra plus commander ce produit, et ses SKU cochés seront abandonnés. Prend effet à l’enregistrement.",
      "removeConfirmCta": "Retirer le marchand",
      "emptyRowTitle": "Chaque marchand doit avoir au moins un SKU",
      "emptyRowDesc": "{{count}} ligne(s) marchand n’ont rien de coché. Cochez au moins un SKU, ou utilisez le bouton retirer pour désaffecter le marchand.",
      "emptyRowHint": "Cochez au moins un SKU, ou retirez ce marchand."
    },
    "createModal": {
      "createSuccess": "Products Special créé",
      "createErrorTitle": "Création impossible",
      "title": "Créer un Products Special",
      "hint": "Choisissez un blueprint à masquer du catalogue partagé et affectez-le à des marchands spécifiques. L'affectation au niveau des variantes peut être affinée après la création, via le bouton « N merchants → ».",
      "blueprintLabel": "Blueprint",
      "blueprintSearchPlaceholder": "Rechercher un blueprint par nom / code…",
      "merchantsLabel": "Marchands",
      "merchantSearchPlaceholder": "Rechercher un marchand par nom / e-mail…",
      "cancel": "Annuler",
      "submitDisabledTitle": "Choisissez 1 blueprint et saisissez ≥ 1 ID de marchand",
      "creating": "Création…",
      "submit": "Créer"
    },
    "status": {
      "Active": "Actif",
      "Inactive": "Inactif"
    },
    "createSheet": {
      "title": "Créer un produit spécial",
      "blueprintLabel": "Blueprint",
      "blueprintSearchPlaceholder": "Sélectionner un blueprint",
      "assignmentHeading": "Affectation SKU et marchand",
      "modeAll": "Appliquer à tous les SKU",
      "modePerSku": "Configurer par SKU",
      "merchantLabel": "Marchand",
      "merchantSearchPlaceholder": "Sélectionner des marchands",
      "colSkuCode": "CODE SKU",
      "colSkuName": "NOM DU SKU",
      "colAssignedMerchants": "MARCHANDS ASSIGNÉS",
      "hiddenSku": "Masqué — non assignable",
      "noSkus": "Ce blueprint n'a encore aucun SKU.",
      "pickBlueprintFirst": "Choisissez un blueprint pour afficher ses SKU.",
      "skusLoadError": "Impossible de charger les SKU.",
      "showingSkus": "Affichage de {{from}} à {{to}} sur {{total}} SKU",
      "skuPaginationAria": "Pagination des SKU",
      "duplicateBlueprint": "Ce blueprint est déjà un produit spécial.",
      "createSuccess": "Produit spécial créé",
      "createErrorTitle": "Impossible de créer le produit spécial",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "editTitle": "Modifier le produit spécial",
      "updateSuccess": "Produit spécial mis à jour",
      "updateErrorTitle": "Impossible d'enregistrer les modifications"
    }
  },
  "bundle": {
    "title": "Lots",
    "subtitle": "Lots multi-produits",
    "columns": {
      "name": "Nom",
      "productCount": "Produits",
      "price": "Prix",
      "isActive": "Actif",
      "code": "Code",
      "components": "Composants",
      "status": "Statut"
    },
    "actions": {
      "create": "Créer un lot",
      "edit": "Modifier",
      "pause": "Suspendre",
      "resume": "Reprendre",
      "delete": "Supprimer"
    },
    "banners": {
      "paused": "Ce lot est suspendu — invisible pour les marchands"
    },
    "fields": {
      "name": "Nom du lot",
      "products": "Produits",
      "price": "Prix du lot (USD)",
      "description": "Description"
    },
    "list": {
      "heading": "Bundles",
      "subtitle": "Combinez plusieurs blueprints en un SKU vendable — prix fixe (USD).",
      "searchPlaceholder": "Rechercher par code ou nom…",
      "totalCount": "{{count}} bundle",
      "loading": "Chargement des bundles…",
      "loadError": "Échec du chargement : {{message}}",
      "empty": "Aucun bundle pour l'instant.",
      "componentCount": "{{count}} blueprint",
      "pageInfo": "Page {{page}} / {{total}}",
      "prev": "Précédent",
      "next": "Suivant",
      "created": "Bundle {{code}} créé"
    },
    "create": {
      "title": "Nouveau bundle",
      "note": "Prix fixe (USD) uniquement. Pas de remise / somme / tarification dynamique.",
      "codeLabel": "Code (MAJUSCULES)",
      "descLabel": "Description (facultatif)",
      "descPlaceholder": "Texte éditorial",
      "priceLabel": "Prix (USD) — fixe",
      "priceHint": "={{cents}} cents — un seul prix ; pas de remise/somme/tarification dynamique.",
      "componentsLabel": "Blueprints composants (2-20)",
      "componentsSearchPlaceholder": "Rechercher des blueprints par nom ou code…",
      "cancel": "Annuler",
      "creating": "Création…",
      "submit": "Créer le bundle",
      "createFailed": "Échec de la création du bundle",
      "networkError": "Erreur réseau — vérifiez la connexion",
      "codePlaceholder": "MUG-COMBO-01",
      "namePlaceholder": "Mug + sticker combo",
      "hint": {
        "code": "Le code doit être en MAJUSCULES, chiffres, _ ou - (sans espaces).",
        "name": "Saisissez un nom de lot.",
        "price": "Le prix doit être supérieur à 0.",
        "components": "Choisissez 2 à 20 modèles de composants."
      }
    },
    "detail": {
      "close": "Fermer",
      "componentsTitle": "Composants ({{count}})",
      "loadingComponents": "Chargement des composants…",
      "noComponents": "Aucun composant."
    }
  },
  "mapping": {
    "title": "Mappings",
    "subtitle": "Mappings produits vers SKU vendeurs",
    "columns": {
      "product": "Produit",
      "vendor": "Vendeur",
      "vendorSku": "SKU vendeur",
      "updatedAt": "Mis à jour",
      "externalSku": "SKU externe",
      "sourceTitle": "Titre source",
      "candidates": "Candidats",
      "ticket": "Ticket",
      "generated": "Généré le"
    },
    "banners": {
      "ticketOnly": "Les mappings sont gérés via tickets de support uniquement — contactez l'admin"
    },
    "actions": {
      "viewHistory": "Voir l'historique"
    },
    "page": {
      "title": "Erreurs de mapping",
      "subtitle": "Mappings SKU qui ne correspondent pas entre la boutique externe et le blueprint interne.",
      "bannerTitle": "Résoudre uniquement avec un ticket de support.",
      "bannerBody1": "Les admins ne peuvent traiter les mappings qu'une fois que le marchand a ouvert un ticket",
      "bannerBody2": "Une résolution sans ticket sera rejetée par le système.",
      "searchPlaceholder": "Rechercher par SKU externe…",
      "ticketOnlyLabel": "Uniquement les lignes avec ticket",
      "pendingCount": "{{count}} en attente",
      "loading": "Chargement des mappings en attente…",
      "loadError": "Échec du chargement :",
      "unknownError": "inconnu",
      "emptyBase": "Aucun mapping en attente",
      "emptyTicketSuffix": " (avec ticket)",
      "candidateSummary": "{{count}} candidat (meilleur {{pct}}%)",
      "openTicket": "Ouvrir le ticket →",
      "noTicketTooltip": "Impossible de résoudre sans ticket",
      "noTicket": "Pas de ticket",
      "pageInfo": "Page {{page}} / {{total}}",
      "prev": "Précédent",
      "next": "Suivant"
    }
  },
  "collection": {
    "title": "Collections",
    "subtitle": "Collections de produits sélectionnés",
    "columns": {
      "name": "Nom",
      "blueprintCount": "Blueprints",
      "isActive": "Active"
    },
    "actions": {
      "create": "Créer une collection"
    },
    "fields": {
      "name": "Nom de la collection",
      "slug": "Slug",
      "blueprints": "Blueprints",
      "description": "Description",
      "seoTitle": "Titre SEO",
      "seoDescription": "Description SEO",
      "image": "Image de couverture"
    },
    "page": {
      "title": "Collections",
      "subtitle": "Regroupez les blueprints pour le filtrage du catalogue et l'affichage sur la page d'accueil. Plusieurs-à-plusieurs, chaque collection a son propre SEO.",
      "newCollection": "Nouvelle collection",
      "searchPlaceholder": "Rechercher par slug ou nom (EN)…",
      "countLabel": "{{count}} collections",
      "loading": "Chargement des collections…",
      "loadError": "Échec du chargement :",
      "empty": "Aucune collection pour le moment.",
      "columns": {
        "slug": "Slug",
        "nameEn": "Nom (EN)",
        "blueprints": "Blueprints",
        "seoIndex": "Index SEO",
        "status": "Statut",
        "sort": "Ordre"
      },
      "blueprintCount": "{{count}} blueprints",
      "indexed": "Indexé",
      "noindex": "Non indexé",
      "pageOf": "Page {{page}} / {{total}}",
      "prev": "Préc.",
      "next": "Suiv."
    },
    "statusLabels": {
      "Active": "Actif",
      "Inactive": "Inactif"
    },
    "toasts": {
      "created": "Collection « {{slug}} » créée"
    },
    "modal": {
      "createError": "Impossible de créer la collection",
      "networkError": "Erreur réseau — vérifiez la connexion",
      "title": "Nouvelle collection",
      "subtitle": "Blueprints plusieurs-à-plusieurs + bloc SEO (titre/canonical/index/mots-clés/description).",
      "nameEn": "Nom (EN)",
      "nameEnPlaceholder": "Summer Tees",
      "nameVi": "Nom (VI, facultatif)",
      "nameViPlaceholder": "Summer Tees",
      "slug": "Slug (kebab-case)",
      "sortOrder": "Ordre de tri",
      "descEn": "Description (EN, facultatif)",
      "descEnPlaceholder": "Texte éditorial",
      "status": "Statut",
      "blueprints": "Blueprints (plusieurs-à-plusieurs)",
      "blueprintsSearchPlaceholder": "Rechercher des blueprints par nom ou code…",
      "blueprintsHelper": "Un blueprint peut appartenir à plusieurs collections.",
      "seoBlock": "Bloc SEO",
      "seoTitle": "Titre",
      "seoCanonical": "URL canonique",
      "seoAllowIndex": "Autoriser l'indexation Google",
      "seoKeywords": "Mots-clés meta (séparés par des virgules)",
      "seoDescription": "Description meta",
      "seoDescriptionPlaceholder": "Sélection de blueprints de t-shirts d'été…",
      "cancel": "Annuler",
      "submitting": "Création…",
      "submit": "Créer la collection",
      "seoTitlePlaceholder": "Summer Tees | PrintWay",
      "seoCanonicalPlaceholder": "https://printway.com/collections/summer-tees",
      "seoKeywordsPlaceholder": "tee, summer, print"
    },
    "list": {
      "colLabel": "Libellé",
      "empty": "Aucune collection ne correspond à ces filtres.",
      "showingRange": "Affichage de {{from}} à {{to}} sur {{total}} collections",
      "searchPlaceholder": "Rechercher des collections...",
      "searchAria": "Rechercher des collections"
    },
    "form": {
      "createTitle": "Créer une collection",
      "editTitle": "Modifier la collection",
      "saveCollection": "Enregistrer la collection",
      "labelLabel": "Libellé",
      "labelPlaceholder": "New",
      "hexLabel": "Couleur HEX",
      "hexPlaceholder": "#E53935",
      "errors": {
        "hexInvalid": "La couleur HEX doit ressembler à #RGB ou #RRGGBB."
      }
    }
  },
  "add_on": {
    "title": "Compléments",
    "subtitle": "Configuration des compléments",
    "tabs": {
      "config": "Configuration",
      "accessories": "Accessoires",
      "gift": "Options cadeau"
    },
    "columns": {
      "name": "Nom",
      "type": "Type",
      "price": "Prix",
      "isActive": "Actif"
    },
    "actions": {
      "create": "Créer un complément",
      "edit": "Modifier",
      "delete": "Supprimer"
    },
    "fields": {
      "name": "Nom",
      "type": "Type",
      "price": "Prix (USD)",
      "description": "Description"
    },
    "page": {
      "subtitle": "Espace de gestion des compléments unifié : Configuration et Options cadeau. Les accessoires sont désormais gérés comme des blueprints d'accessoire dans Produits > Blueprints.",
      "tabsAria": "Sous-onglets des compléments"
    },
    "accessoriesTab": {
      "readonlyNote": "Liste des accessoires (lecture seule). L'édition complète des variantes arrivera dans une mise à jour ultérieure.",
      "empty": "Aucun blueprint accessoire pour l'instant. Marquez un blueprint comme accessoire dans l'éditeur de blueprint.",
      "yes": "Oui",
      "no": "Non",
      "col": {
        "nameEn": "Nom (EN)",
        "standalone": "Vendu seul",
        "variants": "Variantes",
        "firstVariantPrice": "Prix de la première variante",
        "name": "Nom",
        "code": "Code",
        "locations": "Emplacements"
      },
      "note": "Blueprints marqués comme accessoires. Liez-les en tant qu'add-ons à un produit principal ci-dessous.",
      "linkTitle": "Lier un add-on accessoire",
      "mainLabel": "Produit principal",
      "mainPlaceholder": "Sélectionner un blueprint principal",
      "accessoryLabel": "Accessoire",
      "accessoryPlaceholder": "Sélectionner un blueprint accessoire",
      "chargeFeeLabel": "Facturer des frais supplémentaires",
      "fromQtyLabel": "Facturer à partir de l'unité #",
      "linkBtn": "Lier l'add-on",
      "toastLinked": "Add-on accessoire lié",
      "toastLinkFailed": "Impossible de lier l'add-on accessoire",
      "errSelectBoth": "Sélectionnez à la fois un produit principal et un accessoire.",
      "errAlreadyLinked": "Cet accessoire est déjà lié au produit sélectionné.",
      "status": {
        "Active": "Actif",
        "Inactive": "Inactif",
        "Draft": "Brouillon",
        "PendingApproval": "En attente d'approbation"
      }
    },
    "addonsTab": {
      "sectionAria": "Configuration des compléments",
      "newTitle": "Nouveau complément",
      "nameEnLabel": "Nom (anglais)",
      "namePlaceholder": "ex. Couleur du fil",
      "choiceMode": "Mode de choix",
      "choiceModeLabels": {
        "multi": "Choix multiple",
        "single": "Choix unique"
      },
      "required": "Requis",
      "tierPricesTitle": "Prix par palier (au moins une ligne requise)",
      "addTierRow": "+ Ligne de palier",
      "pricePlaceholder": "Prix (centimes)",
      "remove": "Supprimer",
      "saving": "Enregistrement…",
      "submit": "Créer le complément",
      "empty": "Aucun complément — créez-en un ci-dessus.",
      "yes": "Oui",
      "no": "Non",
      "errTierRequired": "Au moins une ligne de prix par palier est requise.",
      "toastCreated": "Complément créé",
      "toastCreateFailed": "Échec de la création du complément",
      "col": {
        "nameEn": "Nom (EN)",
        "choice": "Choix",
        "required": "Requis",
        "tierRows": "Lignes de palier"
      }
    }
  },
  "pricing": {
    "title": "Tarification",
    "subtitle": "Paliers, offres et expédition",
    "tabs": {
      "tiers": "Paliers",
      "deals": "Offres",
      "shipping": "Expédition",
      "shippingRates": "Tarifs d'expédition",
      "history": "Historique"
    },
    "columns": {
      "name": "Nom",
      "minQty": "Qté min",
      "maxQty": "Qté max",
      "price": "Prix",
      "discount": "Remise"
    },
    "actions": {
      "createTier": "Créer un palier",
      "createDeal": "Créer une offre",
      "createShipping": "Créer une règle d'expédition",
      "edit": "Modifier",
      "delete": "Supprimer"
    },
    "fields": {
      "tierName": "Nom du palier",
      "qtyRange": "Plage de quantité",
      "discountPct": "% de remise",
      "validFrom": "Valable du",
      "validTo": "Valable au"
    },
    "page": {
      "subtitle": "Gérez les paliers de prix (par défaut : Standard — de nouveaux paliers peuvent être ajoutés), les offres, les tarifs d'expédition (7 zones × 2 vitesses) et l'historique des changements. Les changements de prix >±10% sur les paliers nécessitent l'approbation d'un Super Admin.",
      "readonlyPre": "Vous n'avez pas la permission",
      "readonlyPost": "La page est en lecture seule.",
      "tabsAria": "Onglets de tarification"
    },
    "common": {
      "retry": "Réessayer",
      "cancel": "Annuler",
      "networkError": "Erreur réseau — vérifiez la connexion"
    },
    "dealsTab": {
      "heading": "Offres",
      "description": "Gérez les offres (volume / revenue / direct). Les nouvelles offres sont toujours créées en Brouillon ; l'approbation + l'activation se font dans une file de révision séparée.",
      "createBtn": "+ Créer une offre",
      "loadError": "Échec du chargement de la liste des offres.",
      "empty": "Aucune offre pour le moment.",
      "table": {
        "type": "Type",
        "reward": "Récompense",
        "scope": "Portée",
        "valid": "Validité",
        "priority": "Priorité",
        "status": "Statut"
      },
      "scopeTiers": " · {{count}} palier(s)",
      "scopeMerchants": " · {{count}} marchand(s)",
      "scopeBlueprints": " · {{count}} blueprint(s)",
      "statusLabels": {
        "Active": "Actif",
        "Draft": "Brouillon",
        "Paused": "En pause",
        "Expired": "Expiré",
        "Archived": "Archivé"
      },
      "validation": {
        "nameRequired": "Le nom (EN) est requis",
        "priorityInt": "La priorité doit être un entier ≥ 0",
        "startRequired": "Le début (Valable du) est requis",
        "endRequired": "La fin (Valable jusqu'au) est requise",
        "endAfterStart": "Valable jusqu'au doit être postérieur à Valable du",
        "cashbackBaseRequired": "le cashback nécessite de choisir une base de cashback",
        "cashbackBaseInvalid": "la base de cashback n'est valide que lorsque reward = cashback",
        "tierRequired": "Sélectionnez au moins 1 palier de prix",
        "blueprintOrMerchantRequired": "Sélectionnez au moins 1 blueprint ou 1 marchand"
      },
      "toast": {
        "createdTitle": "Offre brouillon créée",
        "createFailTitle": "Échec de la création de l'offre"
      },
      "modal": {
        "nameEn": "Nom (EN) *",
        "type": "Type *",
        "dealScope": "Portée de l'offre *",
        "rewardKind": "Type de récompense *",
        "percent": "Pourcentage %",
        "valueCents": "Valeur (cents)",
        "cashbackBase": "Base de cashback *",
        "selectPlaceholder": "— sélectionner —",
        "scope": "Portée",
        "applyTo": "Appliquer à *",
        "pricingTiers": "Paliers de prix (multi-sélection)",
        "blueprints": "Blueprints (multi-sélection)",
        "searchBlueprint": "Rechercher un blueprint…",
        "merchantsOptional": "Marchands — facultatif (laisser vide pour cibler uniquement les blueprints)",
        "searchMerchant": "Rechercher un marchand…",
        "priority": "Priorité *",
        "validFrom": "Valable du *",
        "validUntil": "Valable jusqu'au *",
        "expiryWarning": "Alerte d'expiration (jours)",
        "serverErrors": "Erreurs du serveur :",
        "creating": "Création…",
        "createDraft": "Créer un brouillon"
      }
    },
    "historyTab": {
      "heading": "Historique des prix",
      "descriptionPre": "Journal d'audit des changements de prix (Paliers / Variantes). Pour voir le journal d'audit complet, ouvrez les journaux d'audit avec le filtre ",
      "descriptionPost": ".",
      "auditLink": "Ouvrir les journaux d'audit (PricingTier) →",
      "loadError": "Échec du chargement de l'historique des prix.",
      "empty": "Aucun changement de prix pour le moment.",
      "cols": {
        "changedAt": "Modifié le",
        "tierVariant": "Palier / Variante",
        "before": "Avant",
        "after": "Après",
        "changedBy": "Modifié par",
        "reason": "Raison",
        "source": "Source"
      },
      "tierLevel": "Niveau palier",
      "variant": "Variante",
      "tierId": "tier: {{id}}",
      "variantIds": "bp: {{bp}} · var: {{var}} · tier: {{tier}}"
    },
    "reasonModal": {
      "title": "Confirmer le changement de prix",
      "description": "Une raison est requise pour chaque changement de prix. Votre saisie est enregistrée dans le journal d'audit avec le nouveau prix.",
      "reasonLabel": "Raison",
      "placeholder": "p.ex. Augmentation des coûts T3 selon la facture fournisseur #12345",
      "needMoreOne": "Encore au moins {{count}} caractère requis",
      "needMoreOther": "Encore au moins {{count}} caractères requis",
      "charCount": "{{count}} caractères",
      "saving": "Enregistrement…",
      "confirm": "Confirmer le changement",
      "changes": {
        "sku": "SKU",
        "location": "Emplacement",
        "tier": "Niveau",
        "price": "Ancien → nouveau prix"
      },
      "batchSummary_one": "{{count}} prix modifié — une seule raison pour tous.",
      "batchSummary_other": "{{count}} prix modifiés — une seule raison pour tous."
    },
    "tiersTab": {
      "heading": "Paliers de prix",
      "description": "Paliers de prix (par défaut : Standard) — modification en ligne. Les changements de prix >±10% nécessitent l'approbation d'un Super Admin.",
      "tierCount": "{{count}} paliers",
      "loadError": "Échec du chargement de la liste des paliers de prix.",
      "empty": "Aucun palier de prix pour le moment.",
      "cols": {
        "tier": "Palier",
        "status": "Statut",
        "priority": "Priorité",
        "conditions": "Conditions (Commandes OU GMV)",
        "priceModifier": "Modificateur de prix (bps)",
        "actions": "Actions"
      },
      "statusLabels": {
        "Active": "Actif",
        "Inactive": "Inactif"
      },
      "slugLabel": "slug: {{slug}}",
      "cond": {
        "orders": "Commandes ≥ {{count}}",
        "gmv": "GMV ≥ ${{amount}}",
        "items": "Articles ≥ {{count}}"
      },
      "priceModifierAria": "% de modificateur de prix pour {{name}}",
      "current": "Actuel : {{value}}",
      "modifierRange": "Saisissez une remise entre -50 % et 0 % (majoration non autorisée).",
      "reasonPlaceholder": "Raison du changement (≥ 10 caractères — requis pour activer Enregistrer)",
      "reasonAria": "Raison du changement",
      "reasonHint": "Une raison d'au moins 10 caractères est requise ({{count}}/10) — Enregistrer s'active une fois atteint.",
      "approvalTitle": "Ce changement nécessite l'approbation d'un Super Admin",
      "approvalDelta": "Δ = {{pct}}% > seuil ±10%.",
      "submitting": "Envoi…",
      "submitForApproval": "Soumettre pour approbation",
      "saving": "Enregistrement…",
      "save": "Enregistrer",
      "editHint": "— modifiez la valeur pour éditer —",
      "readOnly": "Lecture seule (nécessite la permission pricing:manage)",
      "footerNotePre": "Le seuil de prix >±10% est automatique. Le serveur le revérifie aussi ; si vous dépassez le seuil, la bannière affiche le bouton",
      "footerNoteMid": " au lieu de ",
      "footerNotePost": ".",
      "toast": {
        "submittedTitle": "Palier {{name}} soumis pour approbation",
        "submittedDesc": "Un Super Admin approuvera le changement >±10%.",
        "savedTitle": "Palier {{name}} enregistré",
        "saveFailTitle": "Échec de l'enregistrement du palier {{name}}"
      }
    }
  },
  "technique": {
    "title": "Techniques",
    "subtitle": "Techniques d'impression et broderie",
    "tabs": {
      "print": "Impression",
      "embroidery": "Broderie"
    },
    "columns": {
      "name": "Nom",
      "type": "Type",
      "basePrice": "Prix de base",
      "isActive": "Active"
    },
    "actions": {
      "create": "Créer une technique",
      "edit": "Modifier",
      "delete": "Supprimer"
    },
    "detail": {
      "toast": {
        "saved": "Enregistré",
        "saveFailed": "Échec de l'enregistrement",
        "deleted": "Technique supprimée",
        "deleteFailed": "Échec de la suppression"
      },
      "notFound": "Technique introuvable.",
      "backToList": "Retour à la liste",
      "back": "Retour aux techniques",
      "active": "Active",
      "inactive": "Inactive",
      "inactiveDraft": "Inactive (brouillon)",
      "codeImmutable": "Code (immuable)",
      "typeImmutable": "Type (immuable)",
      "nameEn": "Nom (EN)",
      "nameVi": "Nom (VI)",
      "nameFr": "Nom (FR)",
      "activeToggleAria": "Bascule actif",
      "digitizingFee": "Frais de numérisation (USD cents)",
      "stitchRanges": "Plages de points",
      "addRange": "Ajouter une plage",
      "rangeMin": "Points min",
      "rangeMax": "Points max",
      "rangeFee": "Frais (cents)",
      "remove": "Retirer",
      "overflowTitle": "Formule de dépassement au-delà du plafond",
      "overflowPer": "Par points (Y)",
      "overflowFee": "Frais cents (X)",
      "overflowDisabled": "Désactivé — aucun frais supplémentaire au-delà de la dernière tranche.",
      "noPricingCutting": "La découpe n'a pas encore de champs de prix.",
      "noPricingBlank": "Les méthodes blank n'ont pas de champs de prix.",
      "noPricingPrint": "Les méthodes d'impression n'ont pas de champs de prix. Le prix réside sur les blueprints / produits.",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "deleteTitle": "Supprimer la technique ?",
      "deleteDesc": "Suppression douce de cette technique. Elle est masquée de la liste et peut être restaurée depuis la base de données."
    },
    "createModal": {
      "subtitle": "Choisissez un type — la broderie requiert une tarification par plage de points + des frais de numérisation.",
      "typeOptions": {
        "print": "Impression (UV / DTF / DTG / Sublimation)",
        "embroidery": "Broderie (plage de points + frais de numérisation)",
        "cutting": "Découpe (laser / gravure — tarification MVP-C)",
        "blank": "Vierge (sans tarification)"
      },
      "code": "Code",
      "codePlaceholder": "ex. dtg, sublimation",
      "codeHint": "Slug : lettres minuscules / chiffres / tirets / underscores, max 50.",
      "activeOnCreation": "Actif à la création",
      "digitizingFeeHint": "Requis pour la broderie — facturé une fois par visuel.",
      "rangeRowHint": "Chaque ligne :",
      "printNote": "Les méthodes d'impression n'ont pas de champs supplémentaires. La tarification se trouve sur les blueprints / produits.",
      "cuttingNoteBefore": "La découpe n'a actuellement aucun champ supplémentaire.",
      "cuttingNoteAfter": "le schéma est reporté à MVP-C. Les règles de tarification y seront ajoutées.",
      "blankNoteBefore": "Les méthodes vierges n'ont",
      "blankNoteStrong": "aucun champ de tarification",
      "blankNoteAfter": "(le backend rejette digitizingFee / embroideryRanges / overflow).",
      "creating": "Création…",
      "submit": "Créer la technique",
      "toast": {
        "created": "Technique créée",
        "createFailed": "Échec de la création de la technique",
        "createFailedFallback": "Échec de la création"
      }
    },
    "create": {
      "titleFallback": "Nouvelle technique de broderie",
      "basicInfo": "Informations de base",
      "name": "Nom",
      "namePlaceholder": "Saisir le nom de la technique",
      "code": "Code",
      "codePlaceholder": "Saisir le code",
      "codeDuplicate": "Ce code est déjà utilisé.",
      "description": "Description",
      "descriptionPlaceholder": "Saisir une description",
      "digitizingFee": "Frais de numérisation du fichier",
      "firstArea": "Première zone de broderie",
      "nextArea": "Zone de broderie suivante",
      "nextAreaHint": "Optionnel. Cochez une zone pour la tarifer séparément ; les zones non cochées utilisent la tarification ci-dessus.",
      "applyPriceToAll": "Appliquer cette tarification à {{count}} zone(s) sélectionnée(s)",
      "applyToAllDisabledHint": "Cochez au moins une zone d’abord.",
      "selectAll": "Tout sélectionner",
      "areaLabel": "Zone : {{area}}",
      "areasLoading": "Chargement des zones d'impression…",
      "areasLoadFailed": "Impossible de charger les zones d'impression.",
      "areasEmpty": "Aucune zone d'impression configurée.",
      "addRange": "Ajouter",
      "rangeMin": "Points minimum",
      "rangeMax": "Points maximum",
      "rangeFee": "Frais de broderie",
      "remove": "Supprimer la ligne",
      "overflowEvery": "Pour chaque tranche de",
      "overflowStitchesAdd": "points supplémentaires, ajouter",
      "overflowPer": "Points supplémentaires par palier",
      "overflowFee": "Frais ajoutés par palier",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "toast": {
        "created": "Technique créée",
        "createFailed": "Échec de la création de la technique",
        "createFailedFallback": "Échec de la création",
        "incomplete": "Enregistrement impossible",
        "incompleteDesc": "Des champs obligatoires sont vides ou invalides — ils sont signalés ci-dessous.",
        "saved": "Technique enregistrée",
        "saveFailed": "Échec de l'enregistrement"
      },
      "rangeError": "Chaque ligne exige un maximum supérieur au minimum et des frais de 0 $ ou plus.",
      "overflowError": "Remplissez les deux champs pour facturer au-delà de la dernière ligne, ou laissez-les vides pour ne rien facturer.",
      "codeLocked": "Le code ne peut pas être modifié après la création.",
      "breadcrumbAria": "Fil d'Ariane",
      "crumbBlueprint": "Blueprint",
      "crumbCreate": "Créer",
      "crumbEdit": "Modifier",
      "bulkPricing": {
        "title": "Modification groupée des prix",
        "description": "Saisissez une grille tarifaire et appliquez-la aux {{count}} zone(s) sélectionnée(s).",
        "overwriteWarning": "Ceci remplace la tarification de chaque zone sélectionnée. Les zones non cochées ne sont pas modifiées.",
        "apply": "Appliquer à {{count}} zone(s)",
        "cancel": "Annuler",
        "invalidHint": "Corrigez la grille tarifaire avant de l’appliquer."
      }
    },
    "cuttingMethods": {
      "heading": "Méthodes de découpe",
      "caption": "Laser / Gravure / Mécanique (tarification par zone reportée MVP-C)",
      "banner": "La tarification par zone de découpe (cuttingRanges) est reportée à MVP-C — la liste n'affiche que le nom/code/bascule d'activation.",
      "codeAria": "Code (slug)",
      "codePlaceholder": "code (ex. laser)",
      "namePlaceholder": "Nom affiché (anglais)",
      "addBtn": "Ajouter une technique de découpe",
      "colCode": "Code",
      "colActions": "Actions",
      "loading": "Chargement…",
      "empty": "Aucune méthode de découpe — ajoutez-en une ci-dessus.",
      "activeToggleTitleActive": "Actif — cliquez pour désactiver",
      "activeToggleTitleInactive": "Inactif — cliquez pour activer",
      "activeToggleAria": "Bascule d'activation pour {{code}}",
      "confirmDelete": "Supprimer la méthode de découpe « {{code}} » ?",
      "toast": {
        "created": "Méthode de découpe créée",
        "deleted": "Méthode de découpe supprimée",
        "createFailed": "Échec de la création de la méthode de découpe",
        "createFailedFallback": "Échec de la création"
      }
    },
    "printMethods": {
      "heading": "Méthodes d'impression",
      "caption": "UV / DTF / DTG / Sublimation",
      "codeAria": "Code (slug)",
      "codePlaceholder": "code (ex. dtg)",
      "namePlaceholder": "Nom affiché (anglais)",
      "addBtn": "Ajouter une méthode d'impression",
      "colCode": "Code",
      "colActions": "Actions",
      "loading": "Chargement…",
      "empty": "Aucune méthode d'impression — ajoutez-en une ci-dessus.",
      "activeToggleTitleActive": "Actif — cliquez pour désactiver",
      "activeToggleTitleInactive": "Inactif — cliquez pour activer",
      "activeToggleAria": "Bascule d'activation pour {{code}}",
      "confirmDelete": "Supprimer la méthode d'impression « {{code}} » ?",
      "toast": {
        "created": "Méthode d'impression créée",
        "deleted": "Méthode d'impression supprimée",
        "createFailed": "Échec de la création de la méthode d'impression",
        "createFailedFallback": "Échec de la création"
      }
    },
    "embroideryMethods": {
      "heading": "Méthodes de broderie",
      "loading": "Chargement…",
      "colMinStitches": "Points min",
      "colMaxStitches": "Points max",
      "colFeeCents": "Frais (centimes USD)",
      "colFeeDisplay": "Frais (affichage)",
      "colActions": "Actions",
      "feeCentsAria": "Frais en centimes",
      "saveRanges": "Enregistrer les plages de points",
      "overflowDescBefore": "Au-delà du maxStitches de la dernière plage, les frais évoluent selon",
      "overflowDescStrong": "+$X par +Y points",
      "overflowPerAria": "Points par palier de dépassement",
      "overflowFeeAria": "Frais en centimes du dépassement",
      "globalDigitizingFee": "Frais de numérisation global",
      "digitizingFeeHint": "Facturé une fois par visuel.",
      "digitizingFeeAria": "Frais de numérisation en centimes",
      "saveDigitizingFee": "Enregistrer les frais de numérisation",
      "toast": {
        "stitchRangesSaved": "Plages de points enregistrées",
        "stitchRangesSaveFailed": "Échec de l'enregistrement des plages de points",
        "digitizingFeeSaved": "Frais de numérisation enregistrés",
        "digitizingFeeSaveFailed": "Échec de l'enregistrement des frais de numérisation",
        "invalidRangesTitle": "Plages de points invalides",
        "invalidRangesDesc": "Chaque ligne nécessite des valeurs min/max/frais valides ; overflow nécessite perStitches ≥ 1 + feeCents ≥ 0.",
        "invalidFeeTitle": "Frais de numérisation invalides",
        "invalidFeeDesc": "Doit être un entier non négatif (centimes)."
      }
    },
    "table": {
      "activate": "Activer",
      "activateDesc": "« {{name}} » ({{code}}) deviendra sélectionnable dans les sélecteurs de produits.",
      "activateTitle": "Activer la technique ?",
      "activeToggleAria": "Bascule d'activation pour {{code}}",
      "allTypes": "Tous les types",
      "bandCountOne": "{{count}} plage",
      "bandCountOther": "{{count}} plages",
      "colAction": "Action",
      "colCode": "Code",
      "colCreatedBy": "Créé par",
      "colCreatedDate": "Date de création",
      "colCreator": "Créateur",
      "colDescription": "Description",
      "colLastUpdate": "Dernière mise à jour",
      "colName": "Nom",
      "colNameCode": "Nom / Code",
      "colUpdatedBy": "Mis à jour par",
      "deactivate": "Désactiver",
      "deactivateDesc": "« {{name}} » ({{code}}) sera masquée des sélecteurs de produits jusqu'à réactivation.",
      "deactivateTitle": "Désactiver la technique ?",
      "descBlank": "Vierge — sans tarification",
      "descCutting": "Méthode de découpe (tarification MVP-C)",
      "descPrint": "Méthode d'impression",
      "digitizingFeeLabel": "Frais de numérisation :",
      "editAria": "Modifier la technique {{code}}",
      "empty": "Aucune technique ne correspond aux filtres actuels.",
      "loadError": "Échec du chargement des techniques.",
      "loading": "Chargement…",
      "newBtn": "Créer une technique",
      "nextPage": "Page suivante",
      "noDigitizingFee": "Aucun frais de numérisation",
      "overflowLabel": "Dépassement :",
      "overflowPer": "par",
      "overflowUnit": "pts",
      "paginationAria": "Pagination des techniques",
      "prevPage": "Page précédente",
      "retry": "Réessayer",
      "rowsPerPage": "Lignes par page :",
      "searchAria": "Rechercher par code ou nom",
      "searchLabel": "Recherche",
      "searchPlaceholder": "Rechercher par code, nom…",
      "showingRange": "Affichage {{from}}–{{to}} sur {{total}} techniques",
      "statusDeleted": "Supprimé",
      "statusFilterAll": "Statut : tous",
      "statusFilterAria": "Filtrer par statut",
      "statusLabel": "Statut",
      "subtitle": "Gérez vos techniques d’impression et de broderie, leurs configurations et vos méthodes de production.",
      "toast": {
        "statusUpdated": "Statut mis à jour",
        "toggleFailed": "Échec de la bascule d'activation"
      },
      "typeLabels": {
        "print": "Impression",
        "embroidery": "Broderie",
        "cutting": "Découpe",
        "blank": "Vierge"
      },
      "working": "Traitement…"
    },
    "treeSelect": {
      "placeholder": "— Sélectionner des techniques d'impression / broderie —",
      "selectedCount": "{{count}} sélectionné(s)",
      "removeAria": "Retirer {{name}}",
      "loading": "Chargement des techniques…",
      "loadError": "Échec du chargement des techniques.",
      "empty": "Aucune technique active configurée.",
      "selectAll": "Tout sélectionner",
      "deselectAll": "Tout désélectionner",
      "clearAll": "Tout effacer",
      "typeLabels": {
        "print": "Impression",
        "embroidery": "Broderie",
        "cutting": "Découpe",
        "blank": "Vierge",
        "engraving": "Gravure"
      }
    },
    "form": {
      "addRange": "Ajouter une plage",
      "cancel": "Annuler",
      "code": "Code",
      "codeHint": "Lettres, chiffres, tiret et tiret bas. Enregistré en minuscules.",
      "codeLocked": "Le code ne peut pas être modifié après la création.",
      "codePlaceholder": "Saisir le code de la technique (ex. DTG-001)",
      "createSubtitle": "Ajouter une nouvelle technique d’impression ou de broderie au système.",
      "createTitle": "Créer une technique d’impression",
      "createTitleEmbroidery": "Créer une technique de broderie",
      "description": "Description",
      "descriptionPlaceholder": "Saisir une brève description de cette technique",
      "digitizingFee": "Frais de numérisation (centimes)",
      "editSubtitle": "Mettre à jour les détails et la configuration de la technique.",
      "editTitle": "Modifier la technique d’impression",
      "editTitleEmbroidery": "Modifier la technique de broderie",
      "embroideryRequiredNote": "Une technique de broderie exige des frais de numérisation et au moins une plage de points avant d’être enregistrée. La tarification de dépassement se règle sur la page de la technique.",
      "name": "Nom",
      "namePlaceholder": "Saisir le nom de la technique",
      "rangeFee": "Frais (centimes)",
      "rangeHint": "Chaque plage requiert un maximum supérieur au minimum et des frais supérieurs ou égaux à zéro.",
      "rangeMax": "Points maximum",
      "rangeMin": "Points minimum",
      "removeRange": "Supprimer",
      "save": "Enregistrer",
      "saveFailed": "Impossible d’enregistrer la technique",
      "stitchRanges": "Plages de points",
      "toastCreated": "Technique créée",
      "toastUpdated": "Technique mise à jour"
    }
  },
  "template": {
    "title": "Modèles",
    "subtitle": "Gestion des modèles graphiques",
    "columns": {
      "name": "Nom",
      "blueprint": "Blueprint",
      "regions": "Régions",
      "updatedAt": "Mis à jour"
    },
    "actions": {
      "create": "Créer un modèle",
      "edit": "Modifier",
      "regionErrors": "Erreurs de région",
      "preview": "Aperçu"
    },
    "regionErrors": {
      "title": "Erreurs de région",
      "lowOpacity": "Faible opacité détectée — l'impression peut être de mauvaise qualité",
      "outsideRegion": "L'élément est hors de la zone d'impression",
      "missingArtwork": "La région n'a pas de graphique",
      "description": "Catalogue des erreurs assignées aux régions du modèle (traits fins, mauvais modèle…). Artwork Doctor les utilise pour bloquer/avertir lors d'un envoi par le marchand.",
      "newError": "+ Nouvelle erreur",
      "empty": "Aucune erreur de région pour l'instant.",
      "edit": "Modifier",
      "delete": "Supprimer",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "confirmDeleteTitle": "Supprimer l'erreur de région ?",
      "confirmDeleteBody": "L'erreur sera retirée du catalogue et supprimée de tous les modèles qui l'utilisent (cascade).",
      "col": {
        "key": "Key",
        "label": "Libellé",
        "severity": "Gravité",
        "actions": "Actions"
      },
      "severity": {
        "errorShort": "Erreur (bloque)",
        "warningShort": "Avertissement",
        "errorOption": "Erreur (bloque le graphique)",
        "warningOption": "Avertissement (souple)"
      },
      "dialog": {
        "editTitle": "Modifier l'erreur de région",
        "newTitle": "Nouvelle erreur de région",
        "keyLabel": "Key *",
        "keyPlaceholder": "ex. : thin_lines",
        "labelEnLabel": "Libellé (EN) *",
        "labelViLabel": "Libellé (VI)",
        "severityLabel": "Gravité"
      },
      "toast": {
        "loadFailed": "Impossible de charger la liste des erreurs de région",
        "keyLabelRequired": "Key et Libellé (EN) sont obligatoires",
        "saveFailed": "Échec de l'enregistrement",
        "updated": "Erreur de région mise à jour",
        "created": "Erreur de région créée",
        "deleteFailed": "Échec de la suppression",
        "deleted": "Erreur de région supprimée"
      }
    },
    "detail": {
      "back": "← Liste",
      "backToList": "← Retour à la liste",
      "notFound": "Modèle introuvable.",
      "deleteBtn": "Supprimer le modèle",
      "resyncTooltip": "Envoyer la spec actuelle vers Artwork Doctor",
      "resyncing": "Envoi…",
      "resync": "Re-sync AD",
      "saving": "Enregistrement…",
      "save": "Enregistrer les modifications",
      "confirmDeleteTitle": "Supprimer le modèle ?",
      "confirmDeleteBody": "Suppression logique du modèle — il peut être restauré depuis le filtre « Afficher les supprimés ».",
      "confirmDeleteYes": "Supprimer",
      "confirmDeleteNo": "Annuler",
      "staleBanner": "Ce modèle a été mis à jour par quelqu'un d'autre. Rechargez pour obtenir la dernière version avant d'enregistrer (les modifications non enregistrées seront perdues).",
      "reload": "Recharger",
      "generalInfo": "Informations générales",
      "nameEn": "Nom (EN) *",
      "code": "Code *",
      "aliasEn": "Alias (EN)",
      "type": "Type *",
      "side": "Côté",
      "productKind": "Type de produit *",
      "nameVi": "Nom (VI)",
      "printTechnology": "Technologie d'impression",
      "printTechnologyHint": "Sélectionnez les technologies d'impression prises en charge par ce modèle (DTG/DTF/UV/Sublimation). Un modèle peut en avoir plusieurs.",
      "descriptionEn": "Description (EN)",
      "isActive": "Actif",
      "areaDetail": "Détail de la zone",
      "selectAll": "Tout",
      "analyzing": "Détection des régions…",
      "uploading": "Téléversement de l'image…",
      "invalidData": "Données invalides.",
      "groupFailed": "Ces régions ne peuvent pas être groupées",
      "toast": {
        "saved": "Modèle enregistré",
        "savedWarnings": "Avertissements : {{warnings}}",
        "savedCode": "Code : {{code}}",
        "staleTitle": "Enregistrement modifié",
        "saveFailed": "Échec de l'enregistrement du modèle",
        "deleted": "Modèle supprimé",
        "deletedDesc": "Supprimé logiquement — il peut être restauré depuis le filtre « Afficher les supprimés ».",
        "deleteFailed": "Échec de la suppression du modèle",
        "resyncFailed": "Échec de la re-synchronisation avec Artwork Doctor",
        "adDisabled": "Artwork Doctor est désactivé",
        "adDisabledReason": "Artwork Doctor est désactivé — la spec n'a pas été envoyée.",
        "pushed": "Spec envoyée vers Artwork Doctor"
      },
      "errors": {
        "network": "Erreur de connexion — vérifiez votre réseau et réessayez.",
        "fieldRequired": "{{field}} est un champ obligatoire",
        "fieldInvalid": "{{field}} est invalide — {{reason}}",
        "atPart": "Partie {{n}}",
        "atLayer": "Calque {{n}}",
        "atRegion": "Zone {{n}}",
        "atArea": "Zone d'impression {{n}}",
        "areaIncomplete": "Zone d'impression {{n}} : {{fields}} — obligatoire avant l'enregistrement",
        "unknownArea": "{{field}} n'est pas dans le catalogue des zones d'impression — choisissez-en une dans la liste",
        "andMore": "…et {{n}} autre(s) problème(s)",
        "noArea": "Le template doit avoir au moins une zone d'impression avant d'être enregistré."
      },
      "validation": {
        "artworkNoRegion": "Le calque artwork de la partie \"{{part}}\" nécessite au moins une zone d'impression dimensionnée.",
        "artworkNoFile": "Le calque artwork de la partie \"{{part}}\" nécessite au moins un fichier."
      },
      "fields": {
        "area": "Zone",
        "bbox": "Cadre englobant",
        "code": "Code",
        "name": "Nom",
        "label": "Libellé",
        "technique": "Technique",
        "regions": "Zones",
        "areas": "Zones d'impression",
        "layers": "Calques",
        "parts": "Parties",
        "type": "Type",
        "productKind": "Type de produit",
        "side": "Face",
        "material": "Matériau",
        "role": "Rôle",
        "imageUrl": "Image",
        "validationRules": "Règles de validation",
        "width": "Largeur",
        "height": "Hauteur",
        "ppi": "PPI",
        "fileFormats": "Formats de fichier"
      }
    },
    "wizard": {
      "pageTitle": "Créer un nouveau modèle",
      "pageSubtitle": "Renseignez les informations générales, les parts/calques et la validation. Les images de zone s'ajoutent sur la page de détail après enregistrement.",
      "cancel": "Annuler",
      "back": "← Retour",
      "next": "Continuer →",
      "submit": "Créer le modèle",
      "submitting": "Création…",
      "stepCounter": "Étape {{current}} / {{total}}",
      "stepperAria": "Progression de la création du modèle",
      "generalInfo": "Informations générales",
      "steps": {
        "info": "Informations générales",
        "parts": "Parts & Calques",
        "validation": "Validation & Canevas"
      },
      "fields": {
        "nameEn": "Nom (EN) *",
        "code": "Code *",
        "codePlaceholder": "genere-auto-depuis-le-nom",
        "codeHint": "Généré automatiquement depuis le Nom (EN). Modifiable. Uniquement a-z, A-Z, 0-9, tiret bas ou trait d'union (1-50 caractères).",
        "aliasEn": "Alias (EN)",
        "type": "Type *",
        "side": "Face",
        "productKind": "Type de produit *",
        "nameVi": "Nom (VI)",
        "printTechnology": "Technologie d'impression",
        "printTechnologyHint": "Sélectionnez les technologies d'impression prises en charge par ce modèle (DTG/DTF/UV/Sublimation).",
        "descriptionEn": "Description (EN)",
        "isActive": "Actif"
      },
      "areaImageUploadFailed": "Échec du téléversement de l'image de zone",
      "invalidData": "Données invalides.",
      "createdTitle": "Modèle créé",
      "createdDesc": "Code : {{code}}. Continuez d'ajouter des images de zone / régions sur la page de détail.",
      "createFailed": "Échec de la création du modèle",
      "errors": {
        "network": "Erreur de connexion — vérifiez votre réseau et réessayez."
      }
    },
    "opacityPreview": {
      "areaPreviewAria": "Aperçu de la zone du template : {{code}}",
      "noImage": "Aucune image de template pour l'instant",
      "dropHint": "Glissez-déposez un fichier PNG ici ou cliquez pour choisir un fichier. Jusqu'à 50 Mo.",
      "chooseFile": "Choisir un fichier",
      "regionsCountOne": "{{count}} région",
      "regionsCountOther": "{{count}} régions",
      "replacePng": "Remplacer le PNG",
      "status": {
        "preflight": "Vérification du fichier",
        "decoding": "Décodage du PNG",
        "classify": "Analyse de l'opacité",
        "label": "Séparation des régions",
        "summarize": "Synthèse des résultats"
      },
      "warningLabel": "Avertissement :",
      "outOfRangeWarning": "{{count}} pixels se situent hors des 5 niveaux d'opacité valides (tolérance ±2 %). Le fichier PNG doit utiliser exactement 5 niveaux d'opacité (0 % / 40 % / 60 % / 80 % / 100 %). Impossible d'enregistrer le template tant que le fichier PNG n'est pas corrigé.",
      "artworkAlt": "Illustration de la zone du template",
      "selectRegionAria": "Sélectionner la région {{bucket}}",
      "bucket": {
        "1": "Arrière-plan",
        "2": "Impression : zone de sécurité",
        "3": "Impression : normale",
        "4": "Découpe : prédécoupe",
        "5": "Découpe : normale"
      }
    },
    "gridOverlay": {
      "uploadHint": "Téléchargez une image de template pour voir les zones d'impression",
      "contoursAlt": "Template avec contours",
      "flipTitle": "Inverser {{name}} dans {{group}}",
      "overlapDetectedOne": "{{count}} chevauchement partiel détecté",
      "overlapDetectedOther": "{{count}} chevauchements partiels détectés",
      "regionTypes": {
        "C": "Découpe",
        "D": "Découpe à la forme",
        "P": "Impression",
        "S": "Zone de sécurité",
        "X": "Inutilisable"
      }
    },
    "nested": {
      "checkManifest": {
        "heading": "Check Manifest (Artwork Doctor)",
        "addLabel": "Ajouter une vérification (choisir un type)",
        "loadingOption": "Chargement…",
        "selectPlaceholder": "— choisir un type de vérification —",
        "paramsSuffix": " · params",
        "add": "+ Ajouter",
        "empty": "Aucune vérification attachée. Choisissez un type ci-dessus pour en ajouter une.",
        "enabled": "activé",
        "remove": "Supprimer",
        "severity": "gravité",
        "severityOptions": {
          "error": "erreur",
          "warning": "avertissement"
        },
        "part": "partie",
        "selectPart": "— choisir une partie —",
        "layer": "couche (zIndex)",
        "selectLayer": "— choisir une couche —",
        "region": "région",
        "selectRegion": "— choisir une région —",
        "params": "Params"
      },
      "layerForm": {
        "zIndex": "zIndex *",
        "material": "Material *",
        "role": "Role *",
        "thickness": "thicknessMm",
        "printSides": "printSides",
        "printSidesCutOnly": "0 (découpe uniquement)",
        "alignTo": "alignTo (réf. couche)",
        "alignToNone": "— aucun —",
        "alignToSymmetric": "symmetric",
        "files": "Fichiers",
        "addFile": "+ Fichier",
        "noFiles": "Aucun fichier.",
        "fileKind": "kind",
        "fileSurface": "surface",
        "imageUrl": "imageUrl",
        "pngButton": "PNG…",
        "removeFile": "Supprimer le fichier",
        "opacityError": "Échec de l'opacity-detect.",
        "opacityResult": "{{count}} région(s) détectée(s) depuis le PNG.",
        "opacityBlocked": " (Pixels hors plage — vérifiez avant d'enregistrer.)",
        "mergeRegions": "Ajouter aux régions",
        "opacityProgress": "Analyse du PNG… {{progress}}%",
        "regions": "Régions",
        "addRegion": "+ Région",
        "noRegions": "Aucune région.",
        "removeLayer": "Supprimer la couche"
      },
      "partAccordion": {
        "heading": "Parts → Layers → Regions",
        "addPart": "+ Ajouter une partie",
        "empty": "Aucune partie. Ajoutez une partie pour commencer.",
        "noCode": "(aucun code)",
        "layerCount": "({{count}} couches)",
        "defaultBadge": "par défaut",
        "legacyBadge": "partie héritée non par défaut",
        "removePart": "Supprimer la partie",
        "code": "Code * (slug)",
        "sortOrder": "sortOrder",
        "isDefault": "isDefault",
        "hasStand": "hasStand",
        "resizeArtwork": "Resize Artwork (AD redimensionne automatiquement)",
        "anchorSize": "Anchor size (taille d'origine, ex. 12x12)",
        "label": "Label ({{lang}}{{required}})",
        "layers": "Couches",
        "addLayer": "+ Ajouter une couche",
        "noLayers": "Aucune couche.",
        "regionCount": "({{count}} régions)"
      },
      "regionErrorAssign": {
        "heading": "Region errors (assigner depuis le catalogue)",
        "loading": "Chargement du catalogue…",
        "empty": "Le catalogue n'a aucune erreur. Créez-en une dans « Region errors » (en-tête)."
      },
      "regionForm": {
        "labelEn": "Label (EN)",
        "kind": "Kind *",
        "technique": "Technique",
        "techniqueBackground": "— (arrière-plan) —",
        "bbox": "bbox {{coord}}",
        "gridX": "gridX",
        "gridY": "gridY",
        "locked": "Locked",
        "contour": "Contour (JSON : [[x,y], …] — coller + valider)",
        "dependsOn": "dependsOn (réfs région)",
        "removeRegion": "Supprimer la région"
      }
    },
    "canvas": {
      "areaBlock": {
        "addArea": "Ajouter une zone",
        "activateAreaAria": "Activer la zone {{n}}",
        "areaTitle": "Zone {{n}}",
        "uploadAria": "Téléverser l'image du modèle",
        "upload": "Téléverser",
        "removeAreaAria": "Supprimer la zone",
        "required": "Obligatoire",
        "area": "Zone",
        "fileFormat": "Format de fichier",
        "regionsTitle": "Régions ({{count}})",
        "regionsEmpty": "Aucune région définie pour cette zone.",
        "regionRequired": "Requis",
        "regionOptional": "Optionnel",
        "toggleRegionsAria": "Afficher ou masquer les régions de la zone {{n}}"
      },
      "areaFields": {
        "selectArea": "Sélectionner une zone…",
        "all": "Tout",
        "widthPx": "Largeur (px)",
        "heightPx": "Hauteur (px)",
        "dpi": "DPI"
      },
      "areaImageUpload": {
        "groupAria": "Image d'arrière-plan de la zone",
        "uploadLabel": "Téléverser l'image du modèle",
        "remove": "Supprimer",
        "previewAlt": "Aperçu de l'arrière-plan de la zone",
        "noRouteTitle": "Aucune route de téléchargement front pour cet identifiant GridFS (R2)",
        "previewUnavailable": "Aperçu indisponible — point de terminaison de téléversement en attente",
        "dropzoneAria": "Cliquez ou glissez pour téléverser l'image du modèle",
        "uploading": "Téléversement…",
        "clickOrDrag": "Cliquez ou glissez pour téléverser",
        "uploadEndpointPending": "Point de terminaison de téléversement en attente"
      },
      "actionButtons": {
        "mismatch": "Mismatch ({{count}})",
        "semiFinish": "Semi-finish ({{count}})",
        "ungroup": "Dégrouper"
      },
      "groupList": {
        "regionOne": "{{count}} région",
        "regionOther": "{{count}} régions",
        "material": "Matériau",
        "none": "— Aucun —",
        "selectRegionsTitle": "Cliquez pour sélectionner les régions de ce groupe",
        "mismatchNoMaterial": "Mismatch — aucun matériau requis",
        "flip": "Retourner",
        "empty": "Aucun groupe — sélectionnez ≥2 régions puis Semi-finish / Mismatch.",
        "materialOptions": {
          "wood": "Bois",
          "acrylic": "Acrylique"
        }
      },
      "areaDetail": {
        "legendCut": "C: Découpe ({{count}})",
        "legendPrint": "P: Impression ({{count}})",
        "all": "Tout",
        "canvasAria": "Canevas des régions de la zone",
        "noRegion": "Aucune région"
      },
      "regionBatchEdit": {
        "title": "Détail de la région",
        "selectedCountOne": "{{count}} région sélectionnée",
        "selectedCountOther": "{{count}} régions sélectionnées",
        "deselectAll": "Tout désélectionner",
        "emptyPrompt": "Sélectionnez une région sur le canevas pour la modifier",
        "label": "Libellé",
        "technique": "Technique",
        "required": "Requis",
        "modeLabel": {
          "label": "Libellé, Requis, Erreur",
          "required": "Requis",
          "regionError": "Erreur de région"
        }
      },
      "regionErrorChecklist": {
        "heading": "Erreurs de région (attribution groupée)",
        "loading": "Chargement du catalogue…",
        "empty": "Aucune erreur dans le catalogue. Créez-en dans « Region errors » (en-tête).",
        "severity": {
          "error": "erreur",
          "warning": "avertissement"
        }
      },
      "regionFieldDropdowns": {
        "mixed": "— Mixte —",
        "noLabel": "(aucun libellé)",
        "techniqueLabel": {
          "printNormal": "Impression : Normal",
          "printSafeZone": "Impression : Zone sûre",
          "cutNormal": "Découpe : Normal",
          "cutDieCut": "Découpe : Emporte-pièce",
          "engraveNormal": "Gravure : Normal",
          "engraveDeep": "Gravure : Profond",
          "background": "(arrière-plan)"
        }
      },
      "validationDetail": {
        "name": "Nom",
        "namePlaceholder": "Nom de la validation",
        "title": "Détail de la validation",
        "export": "Exporter",
        "default": "Par défaut",
        "resize": "Redimensionner",
        "empty": "Aucune validation — cliquez sur + pour en créer une"
      },
      "validationTabs": {
        "tabAria": "Validation {{index}}",
        "defaultStarAria": "Validation par défaut",
        "deleteAria": "Supprimer la validation",
        "addAria": "Ajouter une validation",
        "confirmDeleteTitle": "Supprimer la validation ?",
        "confirmDeleteBefore": "La suppression de « ",
        "confirmDeleteAfter": " » retire cette règle de validation et toutes ses zones. Action irréversible jusqu'à l'enregistrement."
      },
      "groupConflict": {
        "semiConflict": "Les zones sélectionnées appartiennent déjà à un autre groupe semi-fini.",
        "mismatchConflict": "Les zones sélectionnées appartiennent déjà à un autre groupe mismatch.",
        "semiCannotMismatch": "Les zones d'un même groupe semi-fini ne peuvent pas être regroupées en mismatch.",
        "mismatchCannotSemi": "Les zones d'un même groupe mismatch ne peuvent pas être regroupées en semi-fini.",
        "mismatchMinRegions": "Le mismatch nécessite au moins 2 zones sélectionnées.",
        "noMatch": "Les zones sélectionnées ne correspondent à aucun groupe à dissocier."
      },
      "regionBox": {
        "needFlipAria": "Retournement requis (miroir)"
      }
    },
    "contour": {
      "invalidJson": "JSON invalide : {{detail}}",
      "invalidJsonShort": "JSON invalide",
      "mustBePairs": "contour doit être un tableau de paires de nombres [[x,y], …]"
    },
    "createDialog": {
      "namePlaceholder": "My Template"
    }
  },
  "option": {
    "title": "Gérer les options",
    "subtitle": "Gérez les attributs produit et le catalogue de Labels qui les regroupe.",
    "loading": "Chargement…",
    "createdByAdmin": "Admin",
    "editAria": "Modifier {{name}}",
    "editTitle": "Modifier l'option + les valeurs",
    "tabs": {
      "options": "Options",
      "labels": "Labels"
    },
    "search": {
      "placeholder": "Rechercher par nom..."
    },
    "filter": {
      "allLabels": "Tous les labels"
    },
    "columns": {
      "label": "Label",
      "name": "Nom de l'option",
      "values": "Valeurs",
      "createdDate": "Date de création",
      "createdBy": "Créé/Mis à jour par",
      "actions": "Actions"
    },
    "empty": {
      "none": "Aucune option pour l'instant. Utilisez « + Ajouter » pour en créer une.",
      "noMatch": "Aucune option ne correspond au filtre actuel."
    },
    "footer": {
      "total": "Total : {{count}}",
      "show": "Afficher :"
    },
    "types": {
      "color": "Couleur",
      "size": "Taille",
      "dimension": "Dimension",
      "text": "Texte"
    },
    "status": {
      "active": "Actif",
      "inactive": "Inactif"
    },
    "fields": {
      "code": "Code",
      "label": "Label",
      "status": "Statut"
    },
    "actions": {
      "addNew": "+ Ajouter",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "edit": "Modifier",
      "close": "Fermer",
      "enable": "Activer",
      "disable": "Désactiver",
      "deleteOption": "Supprimer l'option"
    },
    "pagination": {
      "first": "Première",
      "previous": "Précédente",
      "next": "Suivante",
      "last": "Dernière"
    },
    "values": {
      "none": "— aucune valeur —",
      "more": "+{{count}} de plus",
      "title": "Valeurs",
      "dialogTitle": "Valeurs de {{name}}",
      "dialogAria": "Toutes les valeurs de cette option",
      "dialogCount": "{{count}} valeurs",
      "dialogClose": "Fermer"
    },
    "create": {
      "title": "Créer une nouvelle option",
      "aria": "Créer une option",
      "nameEnLabel": "Nom de l'option (EN)",
      "nameEnPlaceholder": "ex. Apparel Color",
      "nameViLabel": "Nom de l'option (VI)",
      "nameViPlaceholder": "ex. Màu áo",
      "codePlaceholder": "déduit automatiquement du nom",
      "codeHint": "minuscules_snake_case, immuable après création.",
      "submit": "Créer l'option",
      "submitting": "Création…"
    },
    "edit": {
      "title": "Modifier l'option — {{name}}",
      "aria": "Modifier l'option {{name}}",
      "nameEnLabel": "Nom (EN)",
      "nameViLabel": "Nom (VI)",
      "labelCode": "Label / Code",
      "immutable": "Immuable après création.",
      "noChanges": "Aucune modification à enregistrer",
      "save": "Enregistrer les modifications",
      "saving": "Enregistrement…"
    },
    "value": {
      "labelEnLabel": "Label (EN)",
      "labelEnPlaceholder": "ex. Yellow",
      "labelViLabel": "Label (VI)",
      "labelViPlaceholder": "ex. Vàng",
      "codePlaceholder": "auto",
      "add": "+ Ajouter une valeur",
      "adding": "Ajout…",
      "loading": "Chargement des valeurs…",
      "empty": "Aucune valeur pour l'instant — ajoutez-en une ci-dessus.",
      "columns": {
        "label": "Label",
        "position": "Position",
        "status": "Statut"
      },
      "hexLabel": "Couleur hex",
      "hexPlaceholder": "#FF0000",
      "hexInvalid": "Couleur hex invalide — format #RRGGBB",
      "hexNLabel": "Couleur {{n}}",
      "hexOptional": "optionnel",
      "swatchImageLabel": "Image swatch",
      "swatchUpload": "Téléverser",
      "swatchUploading": "Téléversement…",
      "swatchPreview": "Aperçu",
      "swatchUploadFailed": "Échec du téléversement du swatch"
    },
    "confirm": {
      "deleting": "Suppression…",
      "deleteOptionTitle": "Supprimer l'option « {{name}} » ?",
      "deleteOptionDesc": "Les variantes existantes utilisant cette option ne pourront plus être modifiées ensuite. Cette action est définitive.",
      "deleteValue": "Supprimer la valeur",
      "deleteValueTitle": "Supprimer la valeur « {{label}} » ?",
      "deleteValueDesc": "Si cette valeur est liée à un SKU existant, le serveur bloquera la suppression avec une erreur 409. Sinon, la valeur est supprimée immédiatement."
    },
    "toast": {
      "nameRequired": "Nom requis",
      "nameRequiredDesc": "Saisissez le nom de l'option (EN).",
      "created": "Option créée",
      "createdDesc": "{{name}} prête à l'emploi.",
      "createFailed": "Échec de la création",
      "networkError": "Erreur réseau",
      "updated": "Option mise à jour",
      "saveFailed": "Échec de l'enregistrement",
      "deleted": "Option supprimée",
      "deleteFailed": "Échec de la suppression",
      "labelRequired": "Label requis",
      "valueAdded": "Valeur ajoutée",
      "addValueFailed": "Échec de l'ajout de la valeur",
      "valueUpdated": "Valeur mise à jour",
      "saveValueFailed": "Échec de l'enregistrement de la valeur",
      "valueDeleted": "Valeur supprimée",
      "deleteValueFailed": "Échec de la suppression de la valeur",
      "toggleFailed": "Échec du changement de statut"
    },
    "variantsFacetAssign": {
      "saveSuccess": "Affectation enregistrée",
      "saveErrorTitle": "Impossible d'enregistrer l'affectation",
      "networkCheckError": "Erreur réseau — vérifiez la connexion",
      "title": "Affecter des marchands — {{name}}",
      "hint": "Disposition inversée — choisissez d'abord les variantes, puis les marchands pour une affectation groupée. {{count}} variantes au total.",
      "selectVariantsHeading": "1. Sélectionner les variantes ({{count}} sélectionnées)",
      "selectAllVisible": "Tout sélectionner (visible)",
      "clearSelected": "Effacer ({{count}})",
      "variantSearchPlaceholder": "Rechercher une variante…",
      "axis": {
        "color": "Couleur",
        "size": "Taille"
      },
      "axisOption": "{{label}} : tous",
      "showHidden": "Afficher les masquées",
      "noVariantMatch": "Aucune variante ne correspond au filtre.",
      "hiddenBadge": "Masquée",
      "selectMerchantsHeading": "2. Sélectionner les marchands ({{count}} sélectionnés)",
      "merchantSearchPlaceholder": "Rechercher un marchand…",
      "noMerchant": "Aucun marchand.",
      "bulkApplyLabel": "Affectation groupée : {{variants}} variante × {{merchants}} marchand",
      "bulkApplyHint": "Fusionner avec l'affectation actuelle (n'écrase pas les marchands déjà affectés à d'autres variantes).",
      "saving": "Enregistrement…",
      "apply": "Appliquer",
      "currentToggle": "Affectations actuelles — {{blueprint}} au niveau blueprint · {{variant}} au niveau variante",
      "noAssignment": "Aucune affectation pour le moment.",
      "blueprintLevel": "Niveau blueprint :",
      "merchantCount": "{{count}} marchand",
      "close": "Fermer",
      "loadingMerchants": "Chargement des marchands…",
      "directoryError": "Impossible de charger le répertoire des marchands. Vérifiez votre connexion et réessayez.",
      "noSearchMatch": "Aucun marchand ne correspond à « {{term}} ».",
      "selectedAcrossPages": "{{count}} marchand(s) sélectionné(s), y compris sur d’autres pages."
    },
    "variantsFacetTable": {
      "axis": {
        "color": "Couleur",
        "size": "Taille",
        "stockStatus": "Stock"
      },
      "axisOption": "{{label}} : tous",
      "warningHuge": "⚠ {{count}} SKU — Avertissement >500 variantes",
      "warningLarge": "⚠ {{count}} SKU (blueprint volumineux)",
      "searchPlaceholder": "Rechercher SKU / couleur / taille…",
      "clearFilters": "Effacer les filtres",
      "showingCount": "Affichage de {{shown}} sur {{total}}",
      "colSku": "SKU",
      "colColor": "Couleur",
      "colSize": "Taille",
      "colStock": "Stock",
      "colMerchants": "Marc.",
      "noVariantMatch": "Aucune variante ne correspond au filtre.",
      "stockStatus": {
        "Discontinued": "Abandonné",
        "Hidden": "Masqué"
      }
    },
    "list": {
      "pageTitle": "Options",
      "pageSubtitle": "Gérez les attributs d'option produit, les listes de valeurs, les libellés et les options de variante de fulfillment.",
      "tabOptions": "Options",
      "tabLabels": "Libellés d'option",
      "searchPlaceholder": "Rechercher une option...",
      "searchAria": "Rechercher des options par nom",
      "filterLabelAll": "Libellé d'option : tous",
      "filterLabelAria": "Filtrer par libellé d'option",
      "filterUpdatedByAll": "Modifié par : tous",
      "filterUpdatedByAria": "Filtrer par dernier éditeur",
      "filterLastUpdatedAll": "Dernière modification : toutes",
      "filterDateClear": "Effacer",
      "filterDateClearAria": "Effacer le filtre Dernière mise à jour",
      "filterLoading": "Chargement…",
      "createAction": "Créer une option",
      "working": "Enregistrement…",
      "colLabel": "Libellé",
      "colName": "Nom de l'option",
      "colValues": "Valeurs de l'option",
      "colCreated": "Créé le",
      "colLastUpdated": "Dernière modification",
      "colUpdatedBy": "Modifié par",
      "colStatus": "Statut",
      "colActions": "Actions",
      "noValues": "aucune valeur",
      "showAllValuesAria": "Afficher toutes les valeurs de {{name}}",
      "expandValuesAria": "Afficher {{count}} valeurs de plus de {{name}}",
      "collapseValues": "Réduire",
      "statusToggleAria": "Basculer le statut de {{name}}",
      "editAria": "Modifier {{name}}",
      "statusSaved": "Statut mis à jour.",
      "statusFailed": "Impossible de mettre à jour le statut.",
      "createSaved": "Option créée.",
      "updateSaved": "Option mise à jour.",
      "saveFailed": "Impossible d'enregistrer l'option.",
      "loadError": "Impossible de charger les options.",
      "retry": "Réessayer",
      "empty": "Aucune option ne correspond aux filtres actuels.",
      "rowsPerPage": "Lignes par page :",
      "showingRange": "Affichage {{from}}–{{to}} sur {{total}} options",
      "paginationAria": "Pagination des options",
      "prevPage": "Page précédente",
      "nextPage": "Page suivante",
      "updatedByTooltip": "{{email}} — dernière modification {{at}}",
      "filterDateCancel": "Annuler",
      "filterDateApply": "Appliquer",
      "filterDatePresetToday": "Aujourd'hui",
      "filterDatePresetYesterday": "Hier",
      "filterDatePresetLast7": "7 derniers jours",
      "filterDatePresetLast30": "30 derniers jours"
    },
    "form": {
      "createTitle": "Créer une option",
      "editTitle": "Mettre à jour l'option",
      "labelLabel": "Libellé d'option",
      "labelRequired": "Veuillez sélectionner un libellé d'option.",
      "labelsLoading": "Chargement des libellés d'option…",
      "labelsEmpty": "Aucun libellé d'option actif — ajoutez-en un dans l'onglet Libellés d'option.",
      "nameLabel": "Nom de l'option",
      "namePlaceholder": "Saisissez le nom de l'option",
      "nameHint": "Nom utilisé pour gérer cette option dans le système Admin.",
      "nameRequired": "Veuillez saisir le nom de l'option.",
      "valuesTitle": "Valeurs de l'option",
      "valuesSubtitle": "Ajoutez des valeurs pour cette option. Chaque valeur servira à créer des variantes et générer des SKU.",
      "addValueLabel": "Ajouter une valeur",
      "addValuePlaceholder": "Saisissez une valeur puis appuyez sur Entrée",
      "valuesRequired": "Veuillez saisir au moins une valeur.",
      "valueDuplicate": "La valeur « {{code}} » est déjà dans la liste.",
      "valueCodeInvalid": "Cette valeur ne contient ni lettre ni chiffre pour construire un code.",
      "colHex": "Couleur HEX",
      "colCode": "Code",
      "colDisplayName": "Nom d'affichage",
      "colRemove": "Supprimer la valeur",
      "codeLocked": "Le code ne peut plus être modifié après l'enregistrement.",
      "hexAria": "Couleur HEX de {{code}}",
      "hexPickerAria": "Choisir la couleur de {{code}}",
      "removeValueAria": "Supprimer la valeur {{code}}",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "labelLocked": "Le libellé d’option ne peut plus être changé après la création.",
      "hexNAria": "Couleur HEX {{n}} de {{code}}",
      "hexPickerNAria": "Choisir la couleur {{n}} de {{code}}",
      "addHexAria": "Ajouter une autre couleur à {{code}}",
      "addHexTitle": "Ajouter une couleur (jusqu'à {{max}})",
      "removeHexAria": "Supprimer la couleur {{n}} de {{code}}",
      "hexInvalid": "« {{value}} » n'est pas une couleur HEX valide — utilisez #RRGGBB.",
      "hexRequired": "Une valeur de couleur nécessite au moins une couleur HEX."
    }
  },
  "location": {
    "status": {
      "active": "Actif",
      "inactive": "Inactif"
    },
    "fields": {
      "addrLine1": "Adresse (ligne 1)",
      "addrLine2": "Adresse (ligne 2)",
      "addressHeading": "Adresse de l'entrepôt (expédition)",
      "city": "Ville",
      "code": "Code (immuable)",
      "country": "Pays",
      "countryIso": "Pays (ISO-2)",
      "descriptionEn": "Description (EN)",
      "descriptionVi": "Description (VI)",
      "latitude": "Latitude",
      "logisticsHeading": "Logistique",
      "longitude": "Longitude",
      "name": "Nom",
      "state": "État",
      "status": "Statut",
      "timezone": "Fuseau horaire",
      "zip": "Code postal"
    },
    "placeholders": {
      "addrLine1": "ex. : 7510 Garden Grove Blvd",
      "addrLine2": "Facultatif (Unit/Suite…)",
      "city": "Westminster",
      "country": "Tapez pour rechercher (ex. Vi, Vietnam, VN)",
      "countrySelect": "Sélectionner un pays",
      "countrySearch": "Tapez pour rechercher (ex. VN, Vietnam)",
      "descriptionEn": "ex. Hub de traitement principal desservant l'Asie du Sud-Est",
      "descriptionVi": "Description en vietnamien (optionnel)",
      "name": "Saisir le nom",
      "timezone": "Tapez pour rechercher (ex. Ho_Chi_Minh, Tokyo, UTC)",
      "timezoneSelect": "Sélectionner un fuseau horaire"
    },
    "actions": {
      "cancel": "Annuler",
      "delete": "Supprimer",
      "create": "Créer",
      "save": "Enregistrer",
      "saveChanges": "Enregistrer les modifications",
      "saving": "Enregistrement…",
      "newLocation": "Créer un emplacement"
    },
    "toast": {
      "createFailed": "Impossible de créer l’emplacement",
      "created": "Site créé",
      "statusUpdated": "Statut mis à jour",
      "toggleFailed": "Échec du changement de statut",
      "updateFailed": "Impossible de mettre à jour l’emplacement",
      "updated": "Site mis à jour"
    },
    "form": {
      "description": "Ajouter un nouvel emplacement au système.",
      "editSubtitle": "Mettre à jour les détails et la configuration de l’emplacement.",
      "editTitle": "Mettre à jour l’emplacement",
      "errors": {
        "nameRequired": "Le nom est obligatoire",
        "countryIso": "Le pays doit être un code ISO à 2 lettres (ex. VN, US)",
        "coordsNumeric": "Les coordonnées doivent être numériques",
        "coordsRange": "Coordonnées hors limites",
        "submitFailed": "Échec de l'envoi",
        "fieldRequired": "{{field}} est un champ obligatoire.",
        "addressIncomplete": "L'adresse de l'entrepôt doit inclure la ville, l'état et le code postal.",
        "invalidTimezone": "Le fuseau horaire doit être une zone IANA valide (ex : Asia/Ho_Chi_Minh) — choisissez dans la liste, sans le décalage.",
        "descriptionEnRequired": "La description doit comporter le texte anglais — le champ vietnamien seul ne peut pas être enregistré.",
        "imageRequired": "Choisissez une image pour cet emplacement."
      },
      "imageChange": "Changer",
      "imageCurrent": "Image actuelle",
      "imageDropzone": "Cliquez pour téléverser ou glissez-déposez",
      "imageDropzoneHint": "PNG, JPG jusqu’à {{max}}",
      "imageLabel": "Image",
      "countryLockedHint": "Le pays ne peut plus être modifié après la création d'un emplacement — les pools de fournisseurs, les tarifs d'expédition et les règles fiscales en dépendent.",
      "countryNoMatch": "Aucun pays correspondant.",
      "imageRemove": "Supprimer",
      "imageSizeError": "L’image doit faire {{max}} ou moins.",
      "imageTypeError": "Seules les images PNG, JPG ou WebP sont acceptées.",
      "imageUploadAria": "Téléverser une image d’emplacement",
      "imageUploadError": "L’image n’a pas pu être téléversée.",
      "imageUploading": "Téléversement…",
      "moreSettings": "Autres réglages",
      "newTitle": "Créer un emplacement"
    },
    "list": {
      "activeToggleAria": "Activer/désactiver pour {{code}}",
      "columns": {
        "nameCode": "Nom / Code",
        "country": "Pays",
        "timezone": "Fuseau horaire",
        "status": "Statut",
        "active": "Actif",
        "image": "Image",
        "name": "Nom",
        "code": "Code",
        "createdDate": "Date de création",
        "creator": "Créateur",
        "action": "Action"
      },
      "editAria": "Modifier l’emplacement {{code}}",
      "empty": "Aucun site ne correspond aux filtres actuels.",
      "filters": {
        "search": "Rechercher",
        "searchPlaceholder": "Rechercher par code, nom…",
        "country": "Pays",
        "anyPlaceholder": "Tous",
        "status": "Statut",
        "allStatuses": "Statut : tous",
        "searchAria": "Rechercher des emplacements",
        "statusAria": "Filtrer par statut"
      },
      "heading": "Emplacement",
      "loadFailed": "Échec du chargement",
      "loading": "Chargement…",
      "nextPage": "Page suivante",
      "paginationAria": "Pagination des emplacements",
      "prevPage": "Page précédente",
      "retry": "Réessayer",
      "rowsPerPage": "Lignes par page :",
      "showingRange": "Affichage {{from}}–{{to}} sur {{total}} emplacements",
      "subtitle": "Gérez vos sites de production, les configurations par pays et les usines.",
      "vendorsAria": "Voir les fournisseurs de {{name}}",
      "working": "Traitement…"
    },
    "toggle": {
      "deactivate": "Désactiver",
      "activate": "Activer",
      "deactivateTitle": "Désactiver le site ?",
      "activateTitle": "Activer le site ?",
      "deactivateDesc": "Les blueprints liés à ce site conservent la référence mais il disparaît des sélecteurs jusqu'à sa réactivation.",
      "activateDesc": "Il redevient sélectionnable dans les sélecteurs de blueprint."
    },
    "detail": {
      "toast": {
        "saved": "Enregistré",
        "saveFailed": "Échec de l'enregistrement",
        "deleted": "Site supprimé",
        "deleteFailed": "Échec de la suppression"
      },
      "notFound": "Site introuvable.",
      "backToList": "← Retour à la liste",
      "backToLocations": "← Retour aux Sites",
      "deleteTitle": "Supprimer le site ?",
      "deleteDesc": "Suppression douce de {{code}} — {{name}}. Les blueprints liés à ce site conservent l'id mais le site cesse d'apparaître dans les listes admin."
    },
    "vendors": {
      "colCode": "Code",
      "colCreated": "Date de création",
      "colName": "Nom du fournisseur",
      "colStatus": "Statut",
      "colUpdated": "Dernière mise à jour",
      "colUpdatedBy": "Mis à jour par",
      "empty": "Aucun fournisseur n’est encore enregistré en {{country}}.",
      "loadFailed": "La liste des fournisseurs n’a pas pu être chargée.",
      "paginationAria": "Pagination des fournisseurs",
      "reactivateConfirm": "Réactiver",
      "reactivateDesc": "Le fournisseur reçoit de nouveau des commandes. Un fournisseur suspendu définitivement ne peut pas être réactivé ici.",
      "reactivateTitle": "Réactiver {{name}} ?",
      "reasonHint": "Au moins {{min}} caractères — le motif est conservé dans l’historique des suspensions.",
      "reasonLabel": "Motif",
      "reasonPlaceholderReactivate": "Note facultative pour le journal",
      "reasonPlaceholderSuspend": "Pourquoi ce fournisseur est-il suspendu ?",
      "reasonTooShort": "Le motif doit faire au moins {{min}} caractères.",
      "showingRange": "Affichage {{from}}–{{to}} sur {{total}} fournisseurs",
      "status": {
        "active": "Actif",
        "inactive": "Inactif",
        "pending_activation": "En attente d’activation",
        "suspended": "Suspendu"
      },
      "statusLocked": "{{name}} est {{status}} — l’activation se fait sur la page du fournisseur, pas ici",
      "statusSwitchAria": "{{name}} est {{status}} — appuyez pour changer",
      "subtitle": "Fournisseurs enregistrés en {{country}}, le pays couvert par ce site de production.",
      "suspendConfirm": "Suspendre",
      "suspendDesc": "Le fournisseur cesse de recevoir de nouvelles commandes. La durée de suspension augmente à chaque fois.",
      "suspendTitle": "Suspendre {{name}} ?",
      "title": "Fournisseurs — {{name}}",
      "toast": {
        "suspended": "{{name}} suspendu",
        "reactivated": "{{name}} réactivé",
        "suspendFailed": "Impossible de suspendre le fournisseur",
        "reactivateFailed": "Impossible de réactiver le fournisseur"
      },
      "refreshing": "Actualisation de la liste…"
    }
  },
  "print_area": {
    "title": "Zones d'impression",
    "subtitlePre": "Catalogue des zones d'impression utilisées pour la zone de validation du template.",
    "subtitlePost": "est l'identité machine immuable après création ; seuls le libellé et l'ordre sont modifiables.",
    "actions": {
      "create": "Nouvelle zone d'impression"
    },
    "columns": {
      "code": "Code",
      "label": "Libellé",
      "order": "Ordre",
      "status": "Statut",
      "actions": "Actions"
    },
    "empty": "Aucune zone d'impression pour le moment.",
    "status": {
      "active": "Actif",
      "archived": "Archivé"
    },
    "rowActions": {
      "edit": "Modifier",
      "archive": "Archiver",
      "unarchive": "Désarchiver",
      "delete": "Supprimer"
    },
    "form": {
      "createTitle": "Nouvelle zone d'impression",
      "editTitle": "Modifier la zone d'impression",
      "codeLabel": "Code",
      "codePlaceholder": "ex. chest_pocket",
      "codeImmutableHint": "Le code est immuable après création (identité machine).",
      "labelLabel": "Libellé",
      "orderLabel": "Ordre de tri",
      "orderPlaceholder": "laisser vide → ajouter à la fin",
      "archivedLabel": "Archivé (masqué de la nouvelle liste Zone de validation)",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "saving": "Enregistrement…"
    },
    "delete": {
      "title": "Supprimer la zone d'impression ?",
      "description": "Seules les zones non référencées peuvent être supprimées. Si elle est utilisée, archivez-la plutôt que de la supprimer pour conserver la référence.",
      "confirm": "Supprimer",
      "cancel": "Annuler"
    },
    "validation": {
      "codePattern": "Le code doit commencer par une lettre ou un chiffre, puis ne contenir que des lettres, chiffres, tirets bas ou traits d’union.",
      "codeRequired": "Le code est obligatoire.",
      "labelRequired": "Le libellé est obligatoire.",
      "sortOrderInteger": "L’ordre doit être un nombre entier."
    },
    "toast": {
      "loadFail": "Échec du chargement des zones d'impression",
      "saveFail": "Échec de l'enregistrement",
      "created": "Zone d'impression créée",
      "updated": "Zone d'impression mise à jour",
      "statusFail": "Échec de la mise à jour du statut",
      "archived": "Zone d'impression archivée",
      "unarchived": "Désarchivée",
      "deleteFail": "Échec de la suppression",
      "deleted": "Zone d'impression supprimée"
    }
  },
  "label": {
    "searchPlaceholder": "Rechercher des libellés…",
    "actions": {
      "add": "Ajouter un libellé"
    },
    "columns": {
      "name": "Nom",
      "code": "Code",
      "status": "Statut",
      "actions": "Actions",
      "lastUpdate": "Dernière mise à jour"
    },
    "loading": "Chargement des libellés…",
    "emptyNone": "Aucun libellé pour le moment. Ajoutez-en un pour commencer à grouper les options.",
    "emptySearch": "Aucun libellé ne correspond à la recherche.",
    "status": {
      "Active": "Actif",
      "Inactive": "Inactif"
    },
    "rowActions": {
      "edit": "Modifier"
    },
    "dialog": {
      "editTitle": "Modifier le libellé",
      "createTitle": "Créer un libellé"
    },
    "form": {
      "nameLabel": "Nom",
      "namePlaceholder": "Saisir le nom du libellé",
      "codeLabel": "Code",
      "codePlaceholder": "Généré à partir du nom",
      "codeHint": "Généré automatiquement à partir du nom. Non modifiable.",
      "cancel": "Annuler",
      "saving": "Enregistrement…",
      "saveChanges": "Enregistrer les modifications",
      "creating": "Création…",
      "createLabel": "Créer le libellé",
      "nameHint": "Nom affiché lors du choix d'un libellé d'option."
    },
    "validation": {
      "nameRequired": "Le nom est obligatoire",
      "codeFormat": "Le code doit être en lowercase_snake_case",
      "codeFormatDesc": "Lettres, chiffres, tirets bas uniquement ; doit commencer par une lettre.",
      "codeRequired": "Le code est obligatoire"
    },
    "toast": {
      "updated": "Libellé mis à jour",
      "created": "Libellé créé",
      "updateFailed": "Échec de la mise à jour",
      "createFailed": "Échec de la création",
      "deleted": "Libellé supprimé",
      "deleteFailed": "Échec de la suppression",
      "unknownError": "Erreur inconnue",
      "statusSaved": "Statut du libellé mis à jour",
      "statusFailed": "Impossible de mettre à jour le statut"
    },
    "statusToggleAria": "Basculer le statut de {{name}}",
    "editAria": "Modifier le libellé {{name}}",
    "loadError": "Impossible de charger les libellés.",
    "retry": "Réessayer",
    "rowsPerPage": "Lignes par page",
    "showingRange": "Affichage {{from}}–{{to}} sur {{total}} libellés",
    "prevPage": "Page précédente",
    "nextPage": "Page suivante",
    "paginationAria": "Pagination des libellés"
  },
  "material": {
    "title": "Matériaux",
    "subtitle": "Catalogue des matériaux utilisés par les couches de template (bois, acrylique, tissu…). Les couches référencent les matériaux définis ici.",
    "actions": {
      "create": "Nouveau matériau"
    },
    "empty": "Aucun matériau pour le moment.",
    "columns": {
      "code": "Code",
      "name": "Nom",
      "group": "Groupe",
      "thickness": "Épaisseur (mm)",
      "engravable": "Gravable",
      "status": "Statut",
      "actions": "Actions"
    },
    "status": {
      "active": "Actif",
      "inactive": "Inactif"
    },
    "rowActions": {
      "edit": "Modifier",
      "delete": "Supprimer"
    },
    "form": {
      "createTitle": "Nouveau matériau",
      "editTitle": "Modifier le matériau",
      "codeLabel": "Code",
      "codePlaceholder": "ex. clear_acrylic",
      "nameEnLabel": "Nom (EN)",
      "nameViLabel": "Nom (VI)",
      "groupLabel": "Groupe",
      "groupPlaceholder": "acrylic / wood / fabric",
      "thicknessLabel": "Épaisseur (mm)",
      "thicknessPlaceholder": "laisser vide si non applicable",
      "engravableLabel": "Compatible gravure",
      "activeLabel": "Actif",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "saving": "Enregistrement…"
    },
    "delete": {
      "title": "Supprimer le matériau ?",
      "description": "Le matériau sera retiré du catalogue (suppression douce). Les couches en cours d'utilisation conservent leur référence existante.",
      "confirm": "Supprimer",
      "cancel": "Annuler"
    },
    "validation": {
      "required": "Le code et le nom (EN) sont obligatoires"
    },
    "toast": {
      "loadFail": "Échec du chargement des matériaux",
      "saveFail": "Échec de l'enregistrement",
      "created": "Matériau créé",
      "updated": "Matériau mis à jour",
      "deleteFail": "Échec de la suppression",
      "deleted": "Matériau supprimé"
    }
  },
  "check_type": {
    "title": "Types de contrôle",
    "subtitle": "Registre des contrôles d'Artwork Doctor. Activer/désactiver (checklist) ou avec paramètres (ex. trait minimum). Les admins ajoutent de nouveaux contrôles selon les besoins des nouveaux produits.",
    "actions": {
      "create": "Nouveau type de contrôle"
    },
    "empty": "Aucun type de contrôle pour le moment.",
    "columns": {
      "code": "Code",
      "label": "Libellé",
      "scope": "Portée",
      "params": "Paramètres",
      "severity": "Sévérité",
      "status": "Statut",
      "actions": "Actions"
    },
    "status": {
      "active": "Actif",
      "inactive": "Inactif"
    },
    "rowActions": {
      "edit": "Modifier",
      "delete": "Supprimer"
    },
    "form": {
      "createTitle": "Nouveau type de contrôle",
      "editTitle": "Modifier le type de contrôle",
      "codeLabel": "Code",
      "codePlaceholder": "ex. MIN_STROKE_SIZE",
      "labelEnLabel": "Libellé (EN)",
      "labelViLabel": "Libellé (VI)",
      "scopeLabel": "Portée",
      "severityLabel": "Sévérité par défaut",
      "severityError": "error (bloque)",
      "severityWarning": "warning (souple)",
      "hasParamsLabel": "Avec paramètres (mode param) — décocher = checklist on/off",
      "paramsTitle": "Paramètres (clé → type)",
      "addParam": "Ajouter un paramètre",
      "paramKeyPlaceholder": "ex. minCm",
      "activeLabel": "Actif",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "saving": "Enregistrement…"
    },
    "delete": {
      "title": "Supprimer le type de contrôle ?",
      "description": "Le type de contrôle sera retiré du registre (suppression douce).",
      "confirm": "Supprimer",
      "cancel": "Annuler"
    },
    "validation": {
      "required": "Le code et le libellé (EN) sont obligatoires",
      "paramsRequired": "Le mode param nécessite au moins 1 paramètre"
    },
    "toast": {
      "loadFail": "Échec du chargement des types de contrôle",
      "saveFail": "Échec de l'enregistrement",
      "created": "Type de contrôle créé",
      "updated": "Type de contrôle mis à jour",
      "deleteFail": "Échec de la suppression",
      "deleted": "Type de contrôle supprimé"
    }
  },
  "opacity": {
    "preflight": {
      "invalidMime": "Seuls les fichiers PNG (image/png) sont acceptés. Ce fichier a le type MIME : {{mime}}.",
      "unknownMime": "inconnu",
      "tooLarge": "La taille du fichier dépasse {{mb}} Mo."
    },
    "decode": {
      "failed": "Impossible de décoder le PNG : {{detail}}",
      "badDimensions": "Le PNG a des dimensions invalides.",
      "noCanvas": "Le navigateur ne prend pas en charge le canvas 2D.",
      "noAlpha": "Le PNG n'a pas de canal alpha (tous les pixels sont opaques). Le modèle nécessite un PNG avec plusieurs niveaux de transparence."
    },
    "worker": {
      "runtimeError": "Échec de l'initialisation du worker."
    }
  },
  "blueprintWizard": {
    "title": "Logistique & frais",
    "subtitle": "Service express, douane et manutention pour ce blueprint.",
    "hsCodeLabel": "Code SH",
    "hsCodePlaceholder": "ex. 6109.10",
    "handleFeeLabel": "Frais de manutention",
    "rushSectionLabel": "Frais de service express",
    "rushServiceLabel": "Service",
    "rushFeeLabel": "Frais express",
    "rushFeePlaceholder": "0.00",
    "rushDeadlineLabel": "Délai express (heures)",
    "addRush": "Ajouter un palier express",
    "removeRush": "Supprimer",
    "samplePolicyLabel": "Politique d'échantillon",
    "samplePolicies": {
      "none": "Aucun échantillon",
      "chargeable": "Payant",
      "free_first": "Premier échantillon gratuit"
    },
    "accessorySectionLabel": "Accessoire",
    "isAccessoryLabel": "Ce blueprint est un accessoire complémentaire",
    "chargeAdditionalFromQtyLabel": "Facturer une expédition supplémentaire à partir de la quantité",
    "services": {
      "ECONOMY": "Économique",
      "STANDARD": "Standard",
      "PRIORITY": "Prioritaire",
      "NEXT_DAY": "Lendemain"
    }
  },
  "tiktokLabelEntitlement": {
    "_vgBinding": "vg-binding: P14.1.D-36 — Merchant Detail tiktokLabelEntitled toggle (label-provided shipping bypass grant) across en/vi/fr",
    "title": "Exonération d'expédition avec étiquette fournie",
    "ariaLabel": "Activer/désactiver le droit à l'étiquette fournie",
    "readOnly": "Vous n'avez pas la permission de modifier ce paramètre.",
    "states": {
      "on": "Autorisé",
      "off": "Non autorisé"
    },
    "helper": {
      "on": "Les commandes avec une étiquette d'expédition téléversée (TikTok, Etsy, achetée soi-même) ne paient ni frais d'expédition ni supplément saisonnier — seuls des frais de manutention uniques par commande s'appliquent.",
      "off": "Les commandes avec étiquette paient l'expédition normale. Activez pour permettre à ce marchand d'utiliser des étiquettes téléversées (TikTok, Etsy, achetée soi-même) et de ne payer que la manutention."
    },
    "toasts": {
      "saved": "Droit à l'étiquette mis à jour.",
      "error": "Échec de la mise à jour du droit à l'étiquette."
    }
  },
  "tierFeeTable": {
    "colArea": "Zone",
    "colAdditionalFee": "Prix",
    "colRequired": "Requis",
    "requiredToggleAria": "Basculer « requis » pour {{name}}",
    "feeInputAria": "Frais {{tier}} pour {{name}}",
    "expand": "Développer {{name}}",
    "collapse": "Réduire {{name}}",
    "colDisplay": "Affichage",
    "displayToggleAria": "Afficher {{name}} sur la boutique",
    "selectAllAria": "Tout sélectionner",
    "selectRowAria": "Sélectionner {{name}}",
    "selectedCount": "{{count}} zone(s) sélectionnée(s)",
    "basePriceAria": "Prix de {{name}}",
    "tierRequiredAria": "Basculer « requis » pour {{name}} au palier {{tier}}",
    "tierDisplayAria": "Afficher {{name}} sur la boutique pour le palier {{tier}}",
    "areaFlagScopeHint": "Required / Display s'appliquent à tous les emplacements",
    "tierFlagScopeHint": "Les commutateurs par palier ne concernent que cet emplacement"
  },
  "blueprintLogistics": {
    "columnSku": "SKU",
    "columnStatus": "Statut",
    "columnShippingFee": "Frais d'expédition ($)",
    "columnSeasonalFee": "Frais saisonniers ($)",
    "columnAdditionalFee": "Frais additionnels ($)",
    "columnReciprocalTariff": "Tarif réciproque ($)",
    "defaultLabel": "Par défaut",
    "empty": "Aucun SKU — choisissez d'abord des options dans le bloc Options.",
    "selectAllAria": "Sélectionner tous les SKU",
    "selectRowAria": "Sélectionner {{sku}}",
    "statusToggleAria": "Activer/désactiver {{sku}}",
    "servicesLoading": "Chargement des services…",
    "noServices": "Aucun service d'expédition — ajoutez-en dans Shipping → Methods."
  },
  "accessoryFeeTable": {
    "colAccessory": "Accessoires",
    "colPrice": "Prix",
    "colShippingFee": "Frais d'expédition",
    "colMinQty": "Qté min",
    "colMaxQty": "Qté max",
    "colRequired": "Obligatoire",
    "removeAria": "Retirer {{name}}",
    "collapse": "Réduire {{name}}",
    "expand": "Développer {{name}}",
    "priceAria": "Prix de {{name}}, palier {{tier}}",
    "shippingAria": "Frais d'expédition de {{name}}, palier {{tier}}",
    "minQtyAria": "Quantité minimale de {{name}}",
    "maxQtyAria": "Quantité maximale de {{name}}",
    "requiredAria": "Rendre {{name}} obligatoire",
    "tierMinQtyAria": "Quantité minimale de {{name}}, palier {{tier}}",
    "tierMaxQtyAria": "Quantité maximale de {{name}}, palier {{tier}}",
    "tierRequiredAria": "Rendre {{name}} obligatoire pour le palier {{tier}}"
  }
}
